import React from "react";
import PropTypes from "prop-types";
import "./Icon.scss";

const icons = {
  // Symbols:

  // Uthavner:

  Flytebrygge: (
    <svg viewBox="0 0 150 150">
      <path
        fill="blue"
        transform="scale(0.132, -0.132) translate(0, -1138)"
        d="M498 274q0 57 28.5 105.5t75.5 77t105 28.5t104 -28t76 -76q28 -50 28 -107q0 -58 -28 -104t-76 -75t-104 -29q-58 0 -104.5 28t-75.5 76t-29 104zM287 688h774v-170h-774v170zM549 276q0 -64 46 -109.5t112 -45.5q41 0 77 20q34 22 58 58q20 37 20 77q0 42 -20 78 q-22 34 -58 58q-37 20 -77 20q-66 0 -112 -45t-46 -111zM479 195q3 -4 5 -7q8 -12 14 -22l28 -47q-32 -45 -100 -45q-25 0 -45 16q-23 13 -47 31q-23 14 -47 14q-14 0 -20 -1.5t-17 -6.5q-18 -9 -33 -21l-35 -20q-18 -12 -32 -12q-39 0 -74 26v103q41 -25 74 -25q17 0 34 6 l35 23l35 20q14 9 33 9q22 0 39 -7l36 -24q23 -17 35 -21q12 -6 29 -6q30 0 53 17zM887 121l45 82q30 -25 53 -25q40 0 56.5 9t23.5 16v-103q-6 -6 -28.5 -16t-51.5 -10q-33 0 -53 10q-22 9 -45 37z"
      />
    </svg>
  ),

  Kai: (
    <svg viewBox="0 0 297.6 297.6">
      <g>
        <path
          fill="blue"
          className="st1"
          d="M77.7,68.1h195.1v50H165l0,63.8c-5.7-3.8-11.4-6-17.4-6c-7.2,0-14,2.3-19.5,4.9c-5.5,2.7-9.4,5.4-12,7.5   l0.1-70.3H77.7V68.1z"
        />
        <path
          fill="blue"
          className="st1"
          d="M24.8,240.6c7,4.2,13.2,6.3,18.6,6.3c2.7,0,5.5-0.5,8.5-1.5l8.8-5.8l8.8-5c2.3-1.5,5.1-2.3,8.3-2.3   c3.7,0,6.9,0.6,9.8,1.8l9,6c3.8,2.8,6.8,4.6,8.8,5.3c2,1,4.4,1.5,7.3,1.5l4.8-0.3l4.5-1.8c1.5-0.7,2.9-1.5,4.1-2.4s2.6-2,4.1-3.4   l8.5-5c3.5-1.2,6.4-1.8,8.8-1.8c5.7,0,11.7,2.4,18.1,7.3c6.9,4.8,12.5,7.3,17.1,7.3c2.8,0,5.7-0.5,8.5-1.5l8.8-5.8l9.3-5   c2-1.5,4.8-2.3,8.3-2.3c5,0,11,2.4,17.8,7.3s12.7,7.3,17.6,7.3c6.4,0,11-0.8,14-2.4c3-1.6,5-2.9,6-3.9v25.8c-1,1-3.4,2.3-7.3,4   s-8.1,2.5-12.8,2.5c-2.7,0-5.8-1-9.3-3l-4.8-2.5l-4.5-3.3l-7.5-5c-2.8-1-5.9-1.5-9.3-1.5c-2.3,0-3.9,0.2-4.8,0.5   c-0.8,0-2.2,0.5-4,1.5l-4.5,2.8l-5.8,4l-8.3,5c-2,1-4.5,1.5-7.5,1.5c-3.8,0-7.9-1.3-12-4l-11.3-7.8c-3.7-2.3-7.6-3.5-11.8-3.5   s-8.1,1.2-11.8,3.5l-11.3,7.8c-3.7,2.7-7.6,4-11.8,4s-7.9-1.3-11.3-4c-3.5-1.8-7.4-4.4-11.8-7.8c-3.8-2.3-7.8-3.5-11.8-3.5   c-2.5,0-4.2,0.2-5,0.5c-0.8,0-2.5,0.6-5,1.9c-2.5,1.3-5,2.9-7.5,4.9l-8.8,5c-3,2-5.7,3-8,3c-6.5,0-12.7-2.2-18.6-6.5V240.6z"
        />
        <path
          fill="blue"
          className="st1"
          d="M24.8,200c7,4.2,13.2,6.3,18.6,6.3c2.7,0,5.5-0.5,8.5-1.5l8.8-5.8l8.8-5c2.3-1.5,5.1-2.3,8.3-2.3   c3.7,0,6.9,0.6,9.8,1.8l9,6c3.8,2.8,6.8,4.6,8.8,5.3c2,1,4.4,1.5,7.3,1.5l4.8-0.3l4.5-1.8c1.5-0.7,2.9-1.5,4.1-2.4s2.6-2,4.1-3.4   l8.5-5c3.5-1.2,6.4-1.8,8.8-1.8c5.7,0,11.7,2.4,18.1,7.3c6.9,4.8,12.5,7.3,17.1,7.3c2.8,0,5.7-0.5,8.5-1.5l8.8-5.8l9.3-5   c2-1.5,4.8-2.3,8.3-2.3c5,0,11,2.4,17.8,7.3c6.9,4.8,12.7,7.3,17.6,7.3c6.4,0,11-0.8,14-2.4c3-1.6,5-2.9,6-3.9v25.8   c-1,1-3.4,2.3-7.3,4s-8.1,2.5-12.8,2.5c-2.7,0-5.8-1-9.3-3l-4.8-2.5l-4.5-3.3l-7.5-5c-2.8-1-5.9-1.5-9.3-1.5   c-2.3,0-3.9,0.2-4.8,0.5c-0.8,0-2.2,0.5-4,1.5l-4.5,2.8l-5.8,4l-8.3,5c-2,1-4.5,1.5-7.5,1.5c-3.8,0-7.9-1.3-12-4l-11.3-7.8   c-3.7-2.3-7.6-3.5-11.8-3.5s-8.1,1.2-11.8,3.5l-11.3,7.8c-3.7,2.7-7.6,4-11.8,4s-7.9-1.3-11.3-4c-3.5-1.8-7.4-4.4-11.8-7.8   c-3.8-2.3-7.8-3.5-11.8-3.5c-2.5,0-4.2,0.2-5,0.5c-0.8,0-2.5,0.6-5,1.9c-2.5,1.3-5,2.9-7.5,4.9l-8.8,5c-3,2-5.7,3-8,3   c-6.5,0-12.7-2.2-18.6-6.5V200z"
        />
      </g>
    </svg>
  ),

  Fortoyningsbolter: (
    <svg viewBox="0 0 29.8 29.8">
      <polygon
        fill="blue"
        points="20.8,7 20.8,3.3 9.3,3.2 9.3,7 3.1,7 3.1,10.6 9.3,10.6 9.2,27.2 20.7,27.3 20.8,10.7 27,10.7 27,7 "
      />
      <path fill="blue" className="st1" d="M8.6,15.1c0,0,7.6,2.6,12.8,0" />
      <path fill="blue" className="st1" d="M8.5,18.6c0,0,7.6,2.6,12.8,0" />
      <path fill="blue" className="st1" d="M8.8,22c0,0,7.6,2.6,12.8,0" />
      <path fill="blue" className="st0" d="M9.1,15.8" />
      <g>
        <path fill="blue" className="st2" d="M9.5,13.6c0,0-2.6,1.9,0,3.6" />
        <path fill="blue" className="st2" d="M9.5,17.1c0,0-2.8,1.9,0,3.5" />
        <path fill="blue" className="st2" d="M9.5,20.6c0,0-2.8,1.9,0,3.5" />

        <path fill="blue" className="st2" d="M20.5,13.8c0,0,2.6,1.9,0,3.6" />
        <path fill="blue" className="st2" d="M20.5,17.3c0,0,2.8,1.9,0,3.5" />
        <path fill="blue" className="st2" d="M20.5,20.8c0,0,2.8,1.9,0,3.5" />
      </g>
    </svg>
  ),

  Batutsettingsrampe: (
    <svg viewBox="0 0 290 290">
      <g>
        <path
          fill="blue"
          d="M184.2,214.3c3.9,0,8.5-1.5,13.8-4.4l13.2-7.6c4.1-2.9,8.7-4.4,13.8-4.4c3.9,0,8.5,1.5,13.8,4.4l13.8,8.5
c4.5,2.7,9.1,4.1,13.8,4.1c7.8,0,13.4-0.9,16.6-2.6c3.2-1.8,5.5-3.3,6.9-4.7v30.3c-1.2,1.2-4,2.7-8.4,4.7c-4.4,2-9.5,2.9-15.1,2.9
c-3.3,0-7-1.2-10.9-3.5c-2-1-3.8-2-5.4-2.9s-3.5-2.3-5.4-3.8l-8.8-5.9c-3.3-1.2-7-1.8-10.9-1.8c-2.5,0-4.4,0.1-5.6,0.4
c-1.2,0.3-2.7,0.9-4.7,1.9c-2,1-3.7,2-5.3,3.1c-1.6,1.1-3.8,2.7-6.8,4.8l-9.7,5.9c-2.4,1.2-5.3,1.8-8.8,1.8V214.3z M160.7,107.1
c-2.2-7.1-6.4-15.2-12.8-24.5s-16.8-17-31.3-23.1L96.4,86.8L160.7,107.1z M234.8,181.7L41.4,134.1c-11-3.5-20.6-13.5-28.8-30
c-4.1-8.2-7.2-16.3-9.4-24.1S0,64.6,0,57.1l84.3,25.3l28.8-37.9c5.9,2.5,11.6,5.6,17.2,9.1c5.6,3.5,10.4,7.1,14.5,10.9
c8.2,7.6,14.5,14.2,18.8,19.7c1.6,2.5,3,5.2,4.4,7.9c1.4,2.7,2.7,5.6,4.1,8.5l2.9,9.4l72.9,22.3L234.8,181.7z M46.4,167.3L0,155.3
v-20.6l188.9,48.2l-4.7,18.8l-83.7-21.2c3.5,4.1,5.3,10.8,5.3,20c-2,12.7-5.8,21.9-11.5,27.6c-7.6,7.6-16.8,11.5-27.6,11.5
c-10.4,0-19.5-3.8-27.3-11.5c-7.8-7.6-11.8-16.8-11.8-27.6c0-10.4,3.8-19.7,11.5-27.9C42,169.1,44.5,167.3,46.4,167.3z"
        />
      </g>
    </svg>
  ),

  Fortoyningsboye: (
    <svg viewBox="0 0 297.6 297.6">
      <path
        fill="blue"
        d="M66.3,161l-6.7,4.4c-3.2,1.1-6.1,1.6-9,1.6c-5.6,0-11.8,0.1-32.6-12v28.8c17.3,11.2,25.8,10.5,32.6,10.5       c2.5,0,5.3-1.1,8.4-3.2l7.2-4.1L66.3,161z"
      />
      <path
        fill="blue"
        d="M270.6,167c-5.1,0-11.2-2.5-18.4-7.6c-7.2-5.1-13.4-7.6-18.7-7.6c-3.7,0-6.6,0.8-8.7,2.4l-9.7,5.3       l-9.2,6.1c-3,1.1-6,1.6-9,1.6c-4.7,0-10.7-2.5-17.9-7.6c-4.7-3.6-9.3-5.9-13.6-7c0,8.2,0.1,17.3,0.1,26.6c2.4,0.6,4.7,1.6,7,3       l11.9,8.2c4.4,2.8,8.6,4.2,12.6,4.2c3.2,0,5.8-0.5,7.9-1.6l8.7-5.3l6.1-4.2l4.7-2.9c1.9-1.1,3.3-1.6,4.2-1.6       c0.9-0.4,2.5-0.5,5-0.5c3.5,0,6.8,0.5,9.7,1.6l7.9,5.3l4.7,3.4l5,2.6c3.7,2.1,6.9,3.2,9.7,3.2c4.9,0,6.4-0.3,10.4-2l0.1-26.4       C277.6,167.1,277.2,167,270.6,167z"
      />
      <path
        fill="blue"
        d="M77.8,207.3c2.5-1.6,5.4-2.4,8.8-2.4c3.9,0,7.4,0.6,10.4,1.9l9.6,6.4c4.1,3,7.2,4.9,9.3,5.6    c2.1,1.1,4.7,1.6,7.7,1.6l5.1-0.3l4.8-1.9c1.6-0.7,3.1-1.6,4.4-2.5c1.3-1,2.8-2.2,4.4-3.6l9-5.3c3.7-1.2,6.8-1.9,9.3-1.9    c1.6,0,3.3,0.2,5,0.6c0-8.6-0.1-17.7-0.1-26.5c-1.8-0.4-3.6-0.7-5.4-0.7c-4.4,0-8.5,1.2-12.4,3.7l-11.9,8.2    c-3.9,2.8-8,4.2-12.4,4.2s-8.3-1.4-11.9-4.2c-3.7-1.9-7.8-4.7-12.4-8.2c-4-2.5-8.2-3.7-12.4-3.7c-2.6,0-4.4,0.2-5.3,0.5    c-0.9,0-2.6,0.7-5.3,2c-2.6,1.3-5.3,3-7.9,5.1l-2,1.1l0,26.9l2.2-1.4L77.8,207.3z"
      />
      <path
        fill="blue"
        d="M148,235.5l-12,8.2c-3.9,2.8-8.1,4.3-12.5,4.3c-4.4,0-8.4-1.4-12-4.3c-3.7-2-7.9-4.7-12.5-8.2    c-4.1-2.5-8.2-3.7-12.5-3.7c-2.7,0-4.4,0.2-5.3,0.5c-0.9,0-2.7,0.7-5.3,2c-2.7,1.3-5.3,3.1-8,5.2l-1.6,0.9l0,20.4    c0,0,13.6,13.8,49.6,13.8c37.5,0,49.7-15.1,49.7-15.1s0-11.1-0.1-27.1c-1.6-0.4-3.3-0.6-5.1-0.6C156.1,231.7,151.9,233,148,235.5z    "
      />
      <path
        fill="blue"
        d="M66.3,214.6l-6.7,4.4c-3.2,1.1-6.1,1.6-9,1.6c-5.6,0-11.8,0.1-32.6-12v28.8c17.3,11.2,25.8,10.5,32.6,10.5      c2.5,0,5.3-1.1,8.4-3.2l7.2-4.1L66.3,214.6z"
      />
      <path
        fill="blue"
        d="M270.6,220.6c-5.1,0-11.2-2.5-18.4-7.6c-7.2-5.1-13.4-7.6-18.7-7.6c-3.7,0-6.6,0.8-8.7,2.4l-9.7,5.3      l-9.2,6.1c-3,1.1-6,1.6-9,1.6c-4.7,0-10.7-2.5-17.9-7.6c-4.7-3.6-9.3-5.9-13.6-7c0,8.2,0.1,17.3,0.1,26.6c2.4,0.6,4.7,1.6,7,3      l11.9,8.2c4.4,2.8,8.6,4.2,12.6,4.2c3.2,0,5.8-0.5,7.9-1.6l8.7-5.3l6.1-4.2l4.7-2.9c1.9-1.1,3.3-1.6,4.2-1.6      c0.9-0.4,2.5-0.5,5-0.5c3.5,0,6.8,0.5,9.7,1.6l7.9,5.3l4.7,3.4l5,2.6c3.7,2.1,6.9,3.2,9.7,3.2c4.9,0,6.4-0.3,10.4-2l0.1-26.4      C277.6,220.7,277.2,220.6,270.6,220.6z"
      />
      <path
        fill="blue"
        d="M165.2,117.5c0-1.5-7.3-31.8-45.6-33.5v-6.5c8.3-1.6,14.6-9,14.6-17.8c0-10-8.1-18.1-18.1-18.1s-18.1,8.1-18.1,18.1   c0,8.8,6.3,16.1,14.6,17.8v6.5c-41.7,1.7-46.2,34.3-46.2,34.3l0,42.7l2.5-1.7l9.2-5.3c2.5-1.6,5.4-2.4,8.7-2.4   c3.9,0,7.3,0.6,10.3,1.8l9.5,6.3c4,3,7.1,4.8,9.2,5.5c2.1,1.1,4.7,1.6,7.6,1.6l5-0.3l4.7-1.8c1.6-0.7,3-1.5,4.3-2.5   s2.8-2.2,4.3-3.6l9-5.3c3.7-1.2,6.8-1.8,9.2-1.8c1.7,0,3.5,0.2,5.3,0.7C165.2,132.6,165.2,118,165.2,117.5z M105.9,59.7   c0-5.6,4.5-10.1,10.1-10.1s10.1,4.5,10.1,10.1s-4.5,10.1-10.1,10.1S105.9,65.3,105.9,59.7z"
      />
    </svg>
  ),

  Ankring: (
    <svg viewBox="0 0 150 150">
      <path
        fill="blue"
        transform="scale(0.132, -0.132) translate(0, -1138)"
        d="M532 152v362h-90v68h90v63q-26 13 -47 43q-18 29 -18 60q0 36 27 63q23 27 75 35q45 0 76 -31q29 -31 29 -72q0 -28 -16 -54t-52 -44v-63h86v-68h-84v-360q75 0 135.5 52.5t81.5 102.5h-100v70h195q-9 -96 -63.5 -162.5t-134 -99.5t-153.5 -33q-136 0 -232.5 86 t-119.5 209h193v-70h-95q33 -68 93.5 -108.5t123.5 -48.5zM518 741q0 -21 14 -36q17 -15 37 -15q23 0 37 17q15 14 15 34q0 22 -14.5 37t-37.5 15q-19 0 -34 -15q-17 -14 -17 -37zM1059 885q-33 -33 -58 -33q-19 6 -71 34.5t-72 28.5q-18 0 -78 -30q-59 -33 -69 -33 q-23 0 -75 30t-67 33q-32 -8 -70.5 -33t-70.5 -30q-16 2 -63 31q-42 25 -72 32q-16 0 -76 -30q-59 -33 -72 -33t-34.5 12t-32.5 21v106l22 -10l25 -12q6 -5 20 -8q11 0 23 8l35 18q7 5 18 11t25 12q20 9 41 12q13 0 28 -8l37 -21q10 -6 26 -13q4 -2 17 -7q23 -12 33 -12 q22 0 45 14l49 29q27 15 47 18q18 -2 66.5 -31.5t73.5 -29.5q10 0 30 10l45 22l43 23q18 6 33 6q24 0 76.5 -33t67.5 -33q8 0 28 15l16 11l11 9v-106z"
      />
    </svg>
  ),

  // Aktiviteter:

  Fiske: (
    <svg viewBox="0 0 150 150">
      <path
        fill="red"
        transform="scale(0.132, -0.132) translate(0, -1138)"
        d="M297 270q-36 17 -78 21l-63 4q21 52 71 98t108.5 81.5t94.5 51.5l53 23q0 17 13 63q8 42 20 60q13 0 66 -14.5t98 -22.5q17 -4 39 -7t41 -3q132 0 151 125q0 67 -104 67q-80 0 -180 -41q5 1 14 15q8 10 8 32q0 66 -121 160q30 0 131 -25q50 -12 95.5 -26.5t91.5 -34.5 q85 -34 104 -76q27 -57 27 -133q0 -38 -4 -66.5t-16 -68.5q-18 -69 -48 -123q-25 -50 -55 -74l47 -53l-135 -123l-148 39q-27 -12 -102.5 -29.5t-163.5 -17.5q-109 0 -202 33l14 7q17 8 43 19zM248 350q2 -10 24 -24q16 -11 37 -11t33 17q12 12 12 28q-6 33 -55 33 q-13 -2 -19 -4t-18 -10q-10 -5 -14 -29zM197 401l143 631h41l-133 -594z"
      />
    </svg>
  ),

  Badeplass: (
    <svg viewBox="0 0 290 290">
      <g>
        <path
          fill="red"
          d="M0,221.5c7.2,4.8,14.5,7.2,21.7,7.2c5.1,0,9.6-1.3,13.4-4l12.9-8.3c4.4-2.7,9-4,13.7-4c5.1,0,9.7,1.3,13.7,4l13.2,8.3
     c4.2,2.7,8.9,4,14,4c2.7,0,4.6-0.1,5.7-0.4c1.1-0.3,2.7-0.9,4.6-1.7c1.9-0.9,3.5-1.7,4.9-2.4c1.3-0.8,3.1-2,5.3-3.7
     c2.2-1.7,3.9-3,5.1-3.7c1.2-0.8,2.8-1.4,4.7-2c3-1.5,6.6-2.3,10.6-2.3c6.3,0,13.3,2.7,21,8.2c7.7,5.4,14.3,8.2,19.6,8.2
     c3.6,0,7.1-0.6,10.3-1.7c3.2-1.5,6.6-3.7,10-6.6l10-5.7c2.7-1.5,6.2-2.3,10.6-2.3c5.3,0,10,1.3,14,4l13.4,8.3c4.4,2.7,9.1,4,14,4
     c7.1,0,12.4-0.9,16.2-2.6c3.7-1.7,6.1-3.2,7.3-4.6v30l-8,5.1c-4.2,2.1-9.3,3.1-15.4,3.1c-4.8,0-9.4-1.6-14-4.9l-13.4-8.6
     c-4.8-3.2-9.4-4.9-14-4.9c-5.1,0-9.9,1.6-14.3,4.9l-12.6,8.6c-4.8,3.2-9.4,4.9-14,4.9c-4.8,0-9.3-1.6-13.7-4.9l-13.4-8.9
     c-4.2-3-8.7-4.6-13.4-4.6c-4.6,0-9.3,1.5-14,4.6l-12.9,8.9c-4.8,3.2-9.4,4.9-14,4.9c-5.3,0-10-1.6-14-4.9c-1.9-1.1-3.9-2.4-6-3.9
     c-2.1-1.4-4.4-3.1-6.9-5c-5-3-9.6-4.6-14-4.6c-2.7,0-4.6,0.1-5.7,0.4c-1.1,0.3-2.8,0.9-4.9,1.9L40.6,251l-10,6.3
     c-2.9,1.7-5.8,2.6-8.9,2.6c-7.1,0-14.3-2.8-21.7-8.3V221.5z M143,197.5c-5.1,0-11.9,2.4-20.3,7.2c-7.4,5.1-14.3,7.7-20.6,7.7
     c-5.1,0-12.2-2.6-21.2-7.7c-3.8-2.1-7.4-3.8-10.7-5.1c-3.3-1.3-6.1-2-8.4-2c-1.5,0-3.3,0.5-5.4,1.4l-4,1.1
     c0-10.7,2.2-21.6,6.6-32.9c4.4-11.2,9.9-20.6,16.6-28C82.2,131.7,89,128,96.1,128c20.6,7.4,36.4,11.2,47.5,11.2
     c11.6,0,27.6-3.7,48-11.2c6.7,0,13.9,3.7,21.7,11.2c6.7,7.6,12.2,17.1,16.4,28.3c4.3,11.3,6.4,22.1,6.4,32.6l-6-1.7l-5.1-0.9
     c-5.1,0-11.8,2.4-20,7.2c-8,5.1-15,7.7-20.9,7.7c-5.1,0-11.6-2.6-19.4-7.7C156.3,199.9,149.1,197.5,143,197.5z M104.4,78.8
     c0-8.6,1.7-16.6,5.1-24c4-7.8,8.9-13.8,14.6-18c2.9-2.1,5.9-3.7,9.2-4.9c3.2-1.1,6.9-1.7,10.9-1.7c7.6,0,14.4,2.1,20.3,6.3
     c5.9,4.2,10.7,10.3,14.3,18.2c3.6,7.9,5.4,16,5.4,24.2c0,13.7-3.9,25.4-11.7,34.9c-7.8,9.5-17.3,14.3-28.3,14.3
     c-10.1,0-19.4-4.9-28-14.6C108.3,103.5,104.4,91.9,104.4,78.8z"
        />
      </g>
    </svg>
  ),
  Padling: (
    <svg viewBox="0 0 290 290">
      <g>
        <path
          fill="red"
          d="M70.5,45.4c12.5,0.8,23.2-8.7,24-21.3c0.8-12.5-8.7-23.2-21.3-24C60.8-0.7,50,8.8,49.2,21.4C48.5,33.8,58.1,44.6,70.5,45.4
     z"
        />
        <path
          d="M179.4,114.2c-0.2-1-11.4,1.3-12.3,0L144.7,78c-16.8-28.8-46.4-39-54.7-33.5h-0.1L52.1,68.6l-28,5.6C21.2,75,7,76,5.8,78.3
     C1,87,17,87.3,17,87.3l24.7,31.5c-23.2,0.1-26.5,0.2-26.5,0.2l0.9,52.4c0,0,24.1-0.2,68,0.1l27.6,32c5,14.8,5.8,19.4,15.4,32.4
     c9.4,12.8,44.9,53.6,48.1,54.1c0.7,0.1,17.4-13.5,17-14.4c-1.3-4.6-40.2-52.2-44.5-56.3c-12.7-12.3-18.2-15-29.4-21.4
     c-0.2-0.1-14-15.4-24-26.5H96c101,1.1,132.1-5.2,134.4-6.1c11.2-4.4,14.7-7.7,23.7-15.9c25.6-23.3,31.1-40.2,31.1-40.2
     C285,101.3,215.8,113.9,179.4,114.2z M51.9,118.7L27.1,86.9c0,0,19.4,0.3,32.2-2.2c7.5-1.5,16.8-4.5,16.8-4.5
     c0.2-0.2,10,13.3,11.2,15.3l11.6,22.3C83.3,119.5,64.2,118.6,51.9,118.7z"
        />
      </g>
    </svg>
  ),

  Dykking: (
    <svg viewBox="0 0 150 150">
      <path
        fill="red"
        transform="scale(0.186, -0.186) translate(0, -800)"
        d="M800 0h-800v800h800v-800zM780 20v760h-760v-760h760zM745 621q-23 -22 -40 -22q-9 2 -52 24q-36 19 -49 19q-15 0 -55 -21q-44 -22 -49 -22q-16 0 -51 20t-49 23q-17 -4 -48.5 -22t-50.5 -21q-10 1 -44 21q-21 12 -51 22q-13 0 -53 -21q-45 -22 -51 -22q-8 0 -25 8 l-22 14v73l15 -7l18 -8q2 -2 14 -6q8 0 16 6l25 13l12 8l18 8q13 6 29 9q9 0 19 -6l26 -15l19 -9l12 -5q16 -9 23 -9q15 0 31 10l35 21q17 10 33 13q9 0 44.5 -22t53.5 -22q7 0 21 7l32 16l30 16q13 5 24 5q15 0 53.5 -23t47.5 -23q5 0 20 10l12 8l7 6v-74zM532 417l-39 4 l-23 3q-13 56 -61 82q-29 16 -61 16q-19 0 -38 -5q27 35 85 34q54 0 94 -40q31 -30 43 -94zM746 46h-85l-13 60l-29 113q-22 48 -71 46q-19 -1 -23 -3q-8 27 13 51q17 21 47 31q34 10 62 -2t37 -46l27 -94zM534 385q3 -9 0 -18q-3 -12 -13 -10l-20 3l-54 7q-25 -46 -57 -41 l-65 9q-59 9 -65 12q-17 22 -20 51q-5 48 30 78q33 27 81 24q23 -1 45 -13q46 -25 58 -79l62 -9h11q4 -3 7 -14zM515 338l-14 -29q-45 -91 -122 -87q-90 4 -114 99l48 -8l80 -15q38 0 64 48zM631 43h-523l18 120l10 24q27 49 99 57q38 4 42 2q19 -32 53 -47.5t71 -8.5 q48 8 66 41q3 5 37 9q67 7 95 -54zM404 381q13 24 -2 47l-10 11l-13 10q-13 8 -31 10q-30 5 -55 -14l-12 -16q-9 -16 -7 -29q2 -12 6 -20l110 -16l6 6z"
      />
    </svg>
  ),

  Grillogbaal: (
    <svg viewBox="0 0 150 150">
      <path
        fill="red"
        transform="scale(0.132, -0.132) translate(0, -1138)"
        d="M872 596q0 -73 -51 -105q-44 -25 -119.5 -45t-87.5 -43l-2 21q16 51 82.5 107t93.5 89t27 111q13 -13 37 -49q10 -18 15 -38.5t5 -47.5zM397 709q-28 -47 -28 -117q0 -49 21 -82.5t59 -60.5l45 -39q-149 0 -197 122q-4 11 -6 21t-2 25q0 47 33.5 84.5t74.5 46.5zM745 700 q-9 -71 -34 -102l-84 -84q-58 -53 -58 -86q1 -5 13 -20l14 -23q-68 0 -119 72q-26 35 -39.5 69t-13.5 66q0 85 26.5 127.5t92.5 111.5q60 69 78 121q5 -16 45 -80q37 -57 58 -98.5t21 -73.5zM414 348l-183 -151l-26 -7q-21 0 -41 17q-25 19 -25 55q0 34 25 53l198 95l21 4 q17 0 27 -10.5t12 -26.5q0 -21 -8 -29zM528 348l-24 -158q0 -22 -27.5 -43.5t-62.5 -21.5q-23 3 -42.5 25.5t-19.5 44.5q0 13 6 22q71 121 99 154q12 12 26 12q17 0 30 -9.5t15 -25.5zM768 217l4 -16q0 -41 -35 -64q-18 -12 -41 -12q-37 0 -47 22l-71 189q0 19 14.5 31 t32.5 12q9 0 20 -6zM870 213l-151 145q-12 12 -12 27q0 14 12 31q12 12 31 12q7 0 11 -1t17 -7l201 -125q16 -10 16 -37q0 -28 -22.5 -50t-65.5 -22q-6 3 -37 27z"
      />
    </svg>
  ),

  Lek: (
    <svg viewBox="0 0 150 150">
      <path
        fill="red"
        transform="scale(0.132, -0.132) translate(0, -1138)"
        d="M432 635q100 0 180 31q-87 32 -180 32q-46 0 -84.5 -7t-85.5 -25q16 -6 42 -13.5t42 -11.5q36 -6 86 -6zM729 905h221v-106q-6 -60 -65 -60v-243l53 -27q34 -15 37 -49v-213h-270l2 213q0 19 18 37q19 14 43 24l29 13v243q-56 0 -68 60v108zM784 852q0 -19 2 -29 q0 -12 6 -18t15 -6l31 -2q28 0 38 3t13 11l4 41h-109zM211 709q53 24 98 33q24 5 54 8.5t63 3.5q124 0 229 -45q-24 51 -59 86q-34 31 -76 53q-22 8 -41.5 12t-42.5 4q-63 0 -123.5 -39.5t-101.5 -115.5zM141 635q0 76 40 143t105.5 106.5t143.5 39.5q75 0 141.5 -39.5 t105 -106t38.5 -143.5h-43l-78 -416q-107 -24 -162 -24q-62 0 -170 24l-80 416h-41z"
      />
    </svg>
  ),

  Klatring: (
    <svg viewBox="0 0 297.6 297.6">
      <path
        fill="red"
        xmlns="http://www.w3.org/2000/svg"
        d="M234.7,271.7l-0.2-247.1h-49.9l-5.3,32.7c-0.6-0.9-1.5-1.6-2.6-1.9c-3.9-0.9-4.6,0.1-6.7,1.4l-16.2,21.4  c0,0-25.6-1.6-34.8-3.3c0,0-14.3-6.2-22.9,12.3l-19.9,45.8c-5.6,16.8-9.3,27.5,3.1,38.6l6.1,7.3L78,271.7h5.7l6.9-86.5l13.5,16.1  l28.5,48.9c3.8,6.9,9.8,9,12.5,7.8c0,0,0.9-0.2,2.1-1l-2.4,14.7H234.7z M128.4,100.5c0.1-0.2,0.2-0.5,0.2-0.7l32.6-4.9  c1.4-0.4,2.4-0.4,3-1.1l13.4-26.2l-17.2,106.7l-7.2-43.9c-3.4-11.6-18-6.9-21-4.2l-15.3,9.1C122.3,119,128.4,100.5,128.4,100.5z   M148.2,240.5l-23.8-50.6c-0.1-0.2-5.3-10.6-10.5-20.9l20.1-16l11.2,36c2.6,4.9,4,6.7,9,5.8c0,0,1.4-0.1,3.1-0.9l-7.9,49.3  C149,242.4,148.6,241.4,148.2,240.5z"
      />
    </svg>
  ),

  Sykling: (
    <svg viewBox="0 0 150 150">
      <path
        fill="red"
        transform="scale(0.132, -0.132) translate(0, -1138)"
        d="M662 434h-19q-8 -31 -47 -31q-49 0 -49 72l-164 197l-14 -43q31 -17 57 -43q24 -27 39 -64q12 -35 12 -71q0 -53 -26 -99.5t-73.5 -74t-101.5 -27.5q-83 0 -141.5 59t-58.5 142q0 81 57 141q61 59 143 59q18 0 41 -4l52 154q-28 6 -46 27t-18 49q0 27 21 51q20 20 51 24 l100 -2q8 -1 14 -8q6 -5 7 -16q0 -20 -21 -29l-96 2l-12 -6q-9 -8 -9 -16q0 -29 82 -29l-14 -47h252l14 39l-61 16q-62 15 -62 41l7 14h213q20 -3 20 -26q0 -17 -12 -31l-28 -6q-20 0 -23 -12l-13 -37l74 -156l25 4l28 4q84 0 141 -57q29 -29 44.5 -64t15.5 -77 q0 -54 -25.5 -99.5t-72 -73.5t-103.5 -28q-40 0 -73 12.5t-58 34.5q-45 41 -57 78.5t-12 56.5zM827 489l-39 78q-42 -27 -57 -78h96zM668 494q13 85 92 131l-47 98l-74 -229h29zM76 203h987v-64h-987v64zM584 526l78 224l-254 -2zM276 586q-54 0 -96 -39q-39 -41 -39 -96 q0 -56 39 -96t96 -40q55 0 95.5 39t40.5 97q0 37 -17 65q-15 29 -47 47q-26 -79 -31 -88q-12 -18 -30 -18q-27 0 -27 35q0 5 33 92zM838 586l57 -113l4 -12q0 -24 -27 -27h-145q6 -47 45.5 -82t87.5 -35q57 0 96 39t39 97q0 54 -39 94.5t-96 40.5z"
      />
    </svg>
  ),

  Fottur: (
    <svg viewBox="0 0 290.1 290.3">
      <path
        fill="red"
        d="M189.8,23.2c0,12.8-10.3,23.1-23.1,23.1S143.6,36,143.6,23.2s10.3-23.1,23.1-23.1C179.3,0,189.8,10.5,189.8,23.2z"
      />
      <path
        fill="red"
        d="M130.1,48.1c0,0-15.6-9.9-29.7-2.1C87.5,53,74.1,95.2,77.7,113.1c2.8,14.2,22.6,17.6,22.6,17.6L130.1,48.1z"
      />

      <path
        fill="red"
        d="M229.9,137l-36.3-28l-18.1-30.4c0-0.1,0-0.1,0-0.2c0.3-21.3-10.6-25.2-10.6-25.2c-4.3-2.3-19.6-8.7-25.2-0.3
c-4.9,7.4-28.3,79.1-29.5,83.6c-1.4,5.1-0.6,14.3,0.6,28.7c0.2,2.4-5.5,46.5-7.1,52.9c-3.7,14.7-11.4,57.7-11.7,59
c-2.8,12.8,17.3,18,21.6,4.3c1.7-5.8,15.4-45.8,30.1-93.4c0.2-0.6,27.3,40.7,28.1,41.9s12.3,49.6,12.4,50.2
c4.6,15.1,24.2,13,21-5.8c-1.5-8.9-7.2-49.9-11.5-63.5c-2.1-6.4-33.1-57.5-32.5-60c0.5-2.3,5-26.2,7.3-38.6l14.6,15
c2.2,1.5,38.7,22.4,38.7,22.4C228.7,155.1,238.7,144.8,229.9,137z"
      />
    </svg>
  ),

  // Overnatting :

  // Fasiliteter :

  Ferskvann: (
    <svg viewBox="0 0 150 150">
      <path
        fill="green"
        transform="scale(0.132, -0.132) translate(0, -1138)"
        d="M287 109l-78 491h92l64 -416h272l68 414h90l-80 -489h-428zM877 1012q18 -3 26 -17t8 -34q0 -41 -39 -56l-18 -2h-33v-59l164 2l2 -133h-108q-34 -49 -105 -49q-63 0 -94 43l-25 2h-39q-63 -15 -63 -125h-125q0 89 39 149t91 85.5t95 25.5h90v57h-34q-26 6 -41 21t-15 34 q0 23 17 37q15 17 39 17z"
      />
    </svg>
  ),

  // Offentligtransport:

  Toalett: (
    <svg viewBox="0 0 297.6 297.6">
      <path
        fill="green"
        d="M146.2,137.6c-32.8,0-59.4,14-59.4,31.2s26.6,31.2,59.4,31.2c32.8,0,59.4-14,59.4-31.2S179,137.6,146.2,137.6z    M146.1,186.2c-20.6,0-37.2-8.8-37.2-19.6s16.7-19.6,37.2-19.6s37.2,8.8,37.2,19.6S166.7,186.2,146.1,186.2z"
      />
      <path
        fill="green"
        d="M148.5,277.3c-0.4,0-0.7,0-1.1,0c-3.7-0.1-12.9-0.9-17.6-6.6c-1.3-1.6-2.1-4.4-5.2-18.8c-1-4.6-2-9.3-2.7-12.2   c-0.9-3.4-4.1-5.8-10.1-10.2c-3.4-2.5-7.3-5.3-11.7-9.2c-8.3-7.3-8.5-29.7-8.5-31.4l9,6.6v0c0,3.5,1,14.2,5.4,18.1   c4.1,3.6,7.8,6.3,11.1,8.6c6.6,4.8,11.8,8.5,13.5,15.2c0.8,3.1,1.8,7.7,2.8,12.6c1.1,5.3,2.8,13.1,3.6,15.2   c1.5,1.5,5.2,2.9,10.6,3.1c5.8,0.1,10.4-1.3,12.2-2.9c0.7-2,1.7-8.8,2.4-13.3c0.8-5.4,1.6-11,2.6-14.6c1.6-6,8-10.5,14.8-15.3   c3.8-2.7,7.7-5.5,10.5-8.3c2.5-2.6,3.4-12.4,3.2-18.2l9-6.9c0.1,3,0.4,25.1-5.8,31.3c-3.4,3.4-7.6,6.4-11.7,9.4   c-4.7,3.3-10.5,7.5-11.3,10.3c-0.8,3.1-1.6,8.5-2.4,13.6c-1.7,11.7-2.5,15.7-4.4,17.8C163.2,275,156.4,277.3,148.5,277.3z"
      />
      <path
        fill="green"
        d="M125.7,131.6h40c41.3-27,49.5-106-17.6-106C81.2,25.5,83.2,105.2,125.7,131.6z"
      />
    </svg>
  ),

  Gapahuk: (
    <svg viewBox="0 0 297.6 297.6">
      <path
        fill="green"
        d="M263.3,27.3l-232.8,155v83.9h232.8V242l-27.6-0.6c7.7,0.2,13.3-6.1,6.4-16.1l-16.7-28.6c11.9-1.1,16.1-3.2,17.4-7.7   c0,0,1.9-6.5-4.9-10.2l-9.6-0.9c-8.6-1.1-16.5-1.4-16.5-1.4s-7-10.6-9.9-14.6c-10.6-15.1-19.2-15.1-19.2-15.1   c-6.5-2.8-19.5,3.6-29,10.9c-9.5,7.4-17.9,16.7-25.1,28c-7.3,11.3-10.9,22.6-10.9,33.9c0,15.3,8.6,20.9,11.5,22.3l-73.8,0   l-0.1-47.5L263.3,56.3V27.3z M205.1,214.2l26.3,27.7l-69.7,0.1L205.1,214.2z"
      />
      <path
        fill="green"
        d="M201.8,110.7c-11.4,3.8-17.6,16.2-13.7,27.7c3.8,11.4,16.2,17.6,27.7,13.7c11.4-3.8,17.6-16.2,13.7-27.7   C225.6,113,213.3,106.9,201.8,110.7z"
      />
    </svg>
  ),

  Parkeringsplass: (
    <svg viewBox="0 0 150 150">
      <path
        fill="green"
        transform="scale(0.132, -0.132) translate(0, -1138)"
        d="M256 98v942h416q93 0 157 -36t98 -96t34 -130q0 -73 -35.5 -137t-108.5 -104.5t-172 -40.5h-250v-398h-139zM395 635h250q82 0 127 44.5t45 102.5q0 50 -37 84.5t-108 34.5h-277v-266z"
      />
    </svg>
  ),

  Rasteplass: (
    <svg viewBox="0 0 29.8 29.8">
      <path
        fill="green"
        d="M25.9,15h-5.1l-2-4.8h2.9c0.5,0,0.8-0.4,0.8-1s-0.4-1-0.8-1H8.8c-0.5,0-0.8,0.4-0.8,1s0.4,1,0.8,1h3L9.7,15H4.5  c-0.5,0-1,0.4-1,0.9s0.4,1,1,1h4.4l-2.4,5.6h2.4l2.3-5.6h8.1l2.2,5.6h2.4l-2.3-5.6h4.3c0.5,0,1-0.4,1-1S26.4,15,25.9,15z M11.9,15  l2-4.8h2.7l1.9,4.8H11.9z"
      />
    </svg>
  ),

  // Other:

  search: (
    <svg viewBox="-1 -1 33 33">
      <path d="M31.008 27.231l-7.58-6.447c-0.784-0.705-1.622-1.029-2.299-0.998 1.789-2.096 2.87-4.815 2.87-7.787 0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12c2.972 0 5.691-1.081 7.787-2.87-0.031 0.677 0.293 1.515 0.998 2.299l6.447 7.58c1.104 1.226 2.907 1.33 4.007 0.23s0.997-2.903-0.23-4.007zM12 20c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8z" />
    </svg>
  ),
  pencil: (
    <svg viewBox="0 0 32 32">
      <path d="M27 0c2.761 0 5 2.239 5 5 0 1.126-0.372 2.164-1 3l-2 2-7-7 2-2c0.836-0.628 1.874-1 3-1zM2 23l-2 9 9-2 18.5-18.5-7-7-18.5 18.5zM22.362 11.362l-14 14-1.724-1.724 14-14 1.724 1.724z" />
    </svg>
  ),
  unlock: (
    <svg viewBox="0 0 32 32">
      <path d="M24 2c3.308 0 6 2.692 6 6v6h-4v-6c0-1.103-0.897-2-2-2h-4c-1.103 0-2 0.897-2 2v6h0.5c0.825 0 1.5 0.675 1.5 1.5v15c0 0.825-0.675 1.5-1.5 1.5h-17c-0.825 0-1.5-0.675-1.5-1.5v-15c0-0.825 0.675-1.5 1.5-1.5h12.5v-6c0-3.308 2.692-6 6-6h4z" />
    </svg>
  ),
  checkmark: (
    <svg viewBox="0 0 32 32">
      <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" />
    </svg>
  ),
  userplus: (
    <svg viewBox="0 0 32 32">
      <path d="M12 23c0-4.726 2.996-8.765 7.189-10.319 0.509-1.142 0.811-2.411 0.811-3.681 0-4.971 0-9-6-9s-6 4.029-6 9c0 3.096 1.797 6.191 4 7.432v1.649c-6.784 0.555-12 3.888-12 7.918h12.416c-0.271-0.954-0.416-1.96-0.416-3z" />
      <path d="M23 14c-4.971 0-9 4.029-9 9s4.029 9 9 9c4.971 0 9-4.029 9-9s-4.029-9-9-9zM28 24h-4v4h-2v-4h-4v-2h4v-4h2v4h4v2z" />
    </svg>
  ),
  userminus: (
    <svg viewBox="0 0 32 32">
      <path d="M12 23c0-4.726 2.996-8.765 7.189-10.319 0.509-1.142 0.811-2.411 0.811-3.681 0-4.971 0-9-6-9s-6 4.029-6 9c0 3.096 1.797 6.191 4 7.432v1.649c-6.784 0.555-12 3.888-12 7.918h12.416c-0.271-0.954-0.416-1.96-0.416-3z" />
      <path d="M23 14c-4.971 0-9 4.029-9 9s4.029 9 9 9c4.971 0 9-4.029 9-9s-4.029-9-9-9zM28 24h-10v-2h10v2z" />
    </svg>
  ),
  cross: (
    <svg viewBox="0 0 16 16">
      <path d="M13.957 3.457l-1.414-1.414-4.543 4.543-4.543-4.543-1.414 1.414 4.543 4.543-4.543 4.543 1.414 1.414 4.543-4.543 4.543 4.543 1.414-1.414-4.543-4.543z" />
    </svg>
  ),
  profile: (
    <svg viewBox="0 0 1000 1000">
      <path d="M670.3,574.2c82.9-55.2,137.6-149.4,137.6-256.4c0-170-137.8-307.8-307.8-307.8c-170,0-307.8,137.8-307.8,307.8c0,107,54.7,201.2,137.6,256.4C171.5,637.4,59,786.3,53.2,961.3c0,0-7.6,33.2,55.2,28c26.9-2.2,33.7-28,33.7-28c29.8-190.7,178.5-335.8,358-335.8c179.5,0,328.2,145.1,358,335.8c0,0,17.4,26.1,33.7,28c51.3,5.9,55.2-28,55.2-28C941.3,786.3,828.8,637.4,670.3,574.2z M500.1,541.6c-123.6,0-223.8-100.2-223.8-223.8c0-123.6,100.2-223.8,223.8-223.8C623.8,93.9,724,194.2,724,317.8C724,441.4,623.8,541.6,500.1,541.6z" />
    </svg>
  ),
  share: (
    <svg viewBox="0 0 32 32">
      <path d="M8 20c0 0 1.838-6 12-6v6l12-8-12-8v6c-8 0-12 4.99-12 10zM22 24h-18v-12h3.934c0.315-0.372 0.654-0.729 1.015-1.068 1.374-1.287 3.018-2.27 4.879-2.932h-13.827v20h26v-8.395l-4 2.667v1.728z" />
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 32 32">
      <path d="M29 0h-26c-1.65 0-3 1.35-3 3v26c0 1.65 1.35 3 3 3h13v-14h-4v-4h4v-2c0-3.306 2.694-6 6-6h4v4h-4c-1.1 0-2 0.9-2 2v2h6l-1 4h-5v14h9c1.65 0 3-1.35 3-3v-26c0-1.65-1.35-3-3-3z" />
    </svg>
  ),
  envelope: (
    <svg viewBox="0 0 20 20">
      <path d="M18 2c1.105 0 2 0.895 2 2v0 12c0 1.105-0.895 2-2 2v0h-16c-1.105 0-2-0.895-2-2v0-12c0-1.1 0.9-2 2-2h16zM13.63 11.1l6.37 4.9v-2l-5.12-3.9 5.12-4.1v-2l-10 8-10-8v2l5.12 4.1-5.12 3.9v2l6.37-4.9 3.63 2.9 3.63-2.9z" />
    </svg>
  ),
  twitter: (
    <svg viewBox="0 0 32 32">
      <path d="M31.939 6.092c-1.18 0.519-2.44 0.872-3.767 1.033 1.352-0.815 2.392-2.099 2.884-3.631-1.268 0.74-2.673 1.279-4.169 1.579-1.195-1.279-2.897-2.079-4.788-2.079-3.623 0-6.56 2.937-6.56 6.556 0 0.52 0.060 1.020 0.169 1.499-5.453-0.257-10.287-2.876-13.521-6.835-0.569 0.963-0.888 2.081-0.888 3.3 0 2.28 1.16 4.284 2.917 5.461-1.076-0.035-2.088-0.331-2.971-0.821v0.081c0 3.18 2.257 5.832 5.261 6.436-0.551 0.148-1.132 0.228-1.728 0.228-0.419 0-0.82-0.040-1.221-0.115 0.841 2.604 3.26 4.503 6.139 4.556-2.24 1.759-5.079 2.807-8.136 2.807-0.52 0-1.039-0.031-1.56-0.089 2.919 1.859 6.357 2.945 10.076 2.945 12.072 0 18.665-9.995 18.665-18.648 0-0.279 0-0.56-0.020-0.84 1.281-0.919 2.4-2.080 3.28-3.397l-0.063-0.027z" />
    </svg>
  ),
  load: (
    <svg viewBox="0 0 32 32">
      <path d="M12 4c0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.209-1.791 4-4 4s-4-1.791-4-4zM20.485 7.515c0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.209-1.791 4-4 4s-4-1.791-4-4zM26 16c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM22.485 24.485c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM14 28c0 0 0 0 0 0 0-1.105 0.895-2 2-2s2 0.895 2 2c0 0 0 0 0 0 0 1.105-0.895 2-2 2s-2-0.895-2-2zM5.515 24.485c0 0 0 0 0 0 0-1.105 0.895-2 2-2s2 0.895 2 2c0 0 0 0 0 0 0 1.105-0.895 2-2 2s-2-0.895-2-2zM4.515 7.515c0 0 0 0 0 0 0-1.657 1.343-3 3-3s3 1.343 3 3c0 0 0 0 0 0 0 1.657-1.343 3-3 3s-3-1.343-3-3zM1.75 16c0-1.243 1.007-2.25 2.25-2.25s2.25 1.007 2.25 2.25c0 1.243-1.007 2.25-2.25 2.25s-2.25-1.007-2.25-2.25z" />
    </svg>
  ),
  chevronRight: (
    <svg viewBox="0 0 16 16">
      <path d="M5.5 0l-2 2 6 6-6 6 2 2 8-8-8-8z" />
    </svg>
  ),
  chevronLeft: (
    <svg viewBox="0 0 16 16">
      <path d="M10.5 16l2-2-6-6 6-6-2-2-8 8 8 8z" />
    </svg>
  ),
  info: (
    <svg viewBox="0 0 16 16">
      <path d="M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z" />
      <path d="M10 12h-4v-1h1v-3h-1v-1h3v4h1z" />
      <path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" />
    </svg>
  ),
  expand: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
      <path
        d="M29.40625 5C28.300781 5.050781 27.449219 5.988281 27.5 7.09375C27.550781 8.199219 28.488281 9.050781 29.59375 9L38.1875 9L9 38.1875L9 29.59375C9.007813 29.050781 8.796875 28.53125 8.414063 28.148438C8.03125 27.765625 7.511719 27.554688 6.96875 27.5625C5.863281 27.578125 4.984375 28.488281 5 29.59375L5 45L20.40625 45C21.128906 45.011719 21.796875 44.632813 22.160156 44.007813C22.527344 43.386719 22.527344 42.613281 22.160156 41.992188C21.796875 41.367188 21.128906 40.988281 20.40625 41L11.8125 41L41 11.8125L41 20.40625C40.988281 21.128906 41.367188 21.796875 41.992188 22.160156C42.613281 22.527344 43.386719 22.527344 44.007813 22.160156C44.632813 21.796875 45.011719 21.128906 45 20.40625L45 5L29.59375 5C29.53125 4.996094 29.46875 4.996094 29.40625 5Z"
        fill="currentColor"
      />
    </svg>
  ),
  compress: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
      <path
        d="M45.585938 1.585938L31 16.171875L31 9L27 9L27 23L41 23L41 19L33.828125 19L48.414063 4.414063 Z M 9 27L9 31L16.171875 31L1.585938 45.585938L4.414063 48.414063L19 33.828125L19 41L23 41L23 27Z"
        fill="currentColor"
      />
    </svg>
  ),
  filter: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
      <path
        d="M4 2C3.398438 2 3 2.398438 3 3L3 6C3 6.300781 3.113281 6.488281 3.3125 6.6875L19.3125 23.6875C19.511719 23.886719 19.800781 24 20 24L30 24C30.300781 24 30.488281 23.886719 30.6875 23.6875L46.6875 6.6875C46.886719 6.488281 47 6.300781 47 6L47 3C47 2.398438 46.601563 2 46 2 Z M 19 26L19 41C19 41.398438 19.199219 41.707031 19.5 41.90625L29.5 47.90625C29.601563 48.007813 29.800781 48 30 48C30.199219 48 30.300781 48.007813 30.5 47.90625C30.800781 47.707031 31 47.398438 31 47L31 26Z"
        fill="currentColor"
      />
    </svg>
  ),
  godTurLogo: (
    <svg viewBox="0 0 350 60">
      <image xlinkHref="data:img/png;base64,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" />
    </svg>
  ),
  equalizer: (
    <svg id="icon-equalizer" viewBox="0 0 32 32">
      <path d="M2 14c-1.1 0-2 0.9-2 2s0.9 2 2 2h18v2h4v-2h6c1.1 0 2-0.9 2-2s-0.9-2-2-2h-6v-2h-4v2h-18zM2 26c-1.1 0-2 0.9-2 2s0.9 2 2 2h10v2h4v-2h14c1.1 0 2-0.9 2-2s-0.9-2-2-2h-14v-2h-4v2h-10zM8 0v2h-6c-1.1 0-2 0.9-2 2s0.9 2 2 2h6v2h4v-2h18c1.1 0 2-0.9 2-2s-0.9-2-2-2h-18v-2h-4z" />
    </svg>
  ),
  bin: (
    <svg viewBox="0 0 32 32">
      <path d="M4 10v20c0 1.1 0.9 2 2 2h18c1.1 0 2-0.9 2-2v-20h-22zM10 28h-2v-14h2v14zM14 28h-2v-14h2v14zM18 28h-2v-14h2v14zM22 28h-2v-14h2v14z" />
      <path d="M26.5 4h-6.5v-2.5c0-0.825-0.675-1.5-1.5-1.5h-7c-0.825 0-1.5 0.675-1.5 1.5v2.5h-6.5c-0.825 0-1.5 0.675-1.5 1.5v2.5h26v-2.5c0-0.825-0.675-1.5-1.5-1.5zM18 4h-6v-1.975h6v1.975z" />
    </svg>
  ),
  cloud: (
    <svg viewBox="0 0 32 32">
      <path d="M25.042 18.672v-12.487c0-1.234-1-2.236-2.236-2.236h-19.571c-1.235-0.001-2.236 1.001-2.236 2.236v12.487c0 1.235 1.001 2.236 2.236 2.236h3.729v5.137l5.704-5.137h10.137c1.237 0 2.237-1.001 2.237-2.236zM28.765 8.858h-2.798c0 0 0 9.972 0 10.909s-1.216 2.142-2.153 2.142-10.945 0.055-10.945 0.055c0 1.235 1.001 1.986 2.236 1.986h4.309l5.622 5.102-0.007-5.102h3.736c1.236 0 2.236-0.751 2.236-1.986v-10.932c0-1.234-1-2.174-2.236-2.174z" />
    </svg>
  ),
  bookmark: (
    <svg viewBox="0 0 32 32">
      <path d="M6 0v32l10-10 10 10v-32z" />
    </svg>
  ),
  map: (
    <svg viewBox="0 0 32 28">
      <path d="M31.563 0.172c0.266 0.187 0.438 0.5 0.438 0.828v22c0 0.406-0.25 0.781-0.625 0.922l-10 4c-0.25 0.109-0.5 0.109-0.75 0l-9.625-3.844-9.625 3.844c-0.125 0.063-0.25 0.078-0.375 0.078-0.203 0-0.391-0.063-0.562-0.172-0.266-0.187-0.438-0.5-0.438-0.828v-22c0-0.406 0.25-0.781 0.625-0.922l10-4c0.25-0.109 0.5-0.109 0.75 0l9.625 3.844 9.625-3.844c0.313-0.125 0.656-0.094 0.938 0.094zM11.5 2.281v19.844l9 3.594v-19.844zM2 5.672v19.844l8.5-3.391v-19.844zM30 22.328v-19.844l-8.5 3.391v19.844z" />
    </svg>
  ),
  pin: (
    <svg viewBox="0 0 16 16">
      <path d="M8 0c-2.761 0-5 2.239-5 5 0 5 5 9 5 9s5-4 5-9c0-2.761-2.239-5-5-5zM8 8.063c-1.691 0-3.063-1.371-3.063-3.063s1.371-3.063 3.063-3.063 3.063 1.371 3.063 3.063-1.371 3.063-3.063 3.063zM6.063 5c0 1.070 0.867 1.938 1.938 1.938s1.938-0.867 1.938-1.938-0.867-1.938-1.938-1.938c-1.070 0-1.938 0.867-1.938 1.938zM12.285 10.9c-0.222 0.348-0.451 0.678-0.682 0.988 0.037 0.017 0.073 0.035 0.108 0.052 0.76 0.38 1.101 0.806 1.101 1.059s-0.34 0.679-1.101 1.059c-0.957 0.479-2.31 0.753-3.712 0.753s-2.754-0.275-3.712-0.753c-0.76-0.38-1.101-0.806-1.101-1.059s0.34-0.679 1.101-1.059c0.036-0.018 0.072-0.035 0.108-0.052-0.231-0.31-0.461-0.64-0.682-0.988-1.061 0.541-1.715 1.282-1.715 2.1 0 1.657 2.686 3 6 3s6-1.343 6-3c0-0.817-0.654-1.558-1.715-2.1z" />
    </svg>
  ),
  triangle_up: (
    <svg viewBox="0 0 32 32">
      <path d="M 4,26 16,6 28,26 Z" />
    </svg>
  ),

  triangle_down: (
    <svg viewBox="0 0 32 32">
      <path d="M 28,6 16,26 4,6 Z" />
    </svg>
  ),
  line: (
    <svg viewBox="0 0 24 24">
      <path d="M23.016 8.016c0 1.078-0.938 1.969-2.016 1.969-0.188 0-0.375 0-0.516-0.047l-3.563 3.563c0.047 0.141 0.094 0.328 0.094 0.516 0 1.078-0.938 1.969-2.016 1.969s-2.016-0.891-2.016-1.969c0-0.188 0.047-0.375 0.094-0.516l-2.578-2.578c-0.141 0.047-0.328 0.094-0.516 0.094s-0.375-0.047-0.516-0.094l-4.547 4.547c0.047 0.141 0.094 0.328 0.094 0.516 0 1.078-0.938 2.016-2.016 2.016s-2.016-0.938-2.016-2.016 0.938-1.969 2.016-1.969c0.188 0 0.375 0 0.516 0.047l4.547-4.547c-0.047-0.141-0.047-0.328-0.047-0.516 0-1.078 0.891-2.016 1.969-2.016s2.016 0.938 2.016 2.016c0 0.188 0 0.375-0.047 0.516l2.531 2.531c0.141-0.047 0.328-0.047 0.516-0.047s0.375 0 0.516 0.047l3.563-3.516c-0.047-0.141-0.094-0.328-0.094-0.516 0-1.078 0.938-2.016 2.016-2.016s2.016 0.938 2.016 2.016z" />
    </svg>
  ),
  point: (
    <svg viewBox="0 0 24 24">
      <path d="M5.016 20.016h13.969v1.969h-13.969v-1.969zM9.984 8.016c0 1.078 0.938 1.969 2.016 1.969 1.125 0 2.016-0.891 2.016-1.969s-0.938-2.016-2.016-2.016-2.016 0.938-2.016 2.016zM18 8.016c0 4.5-6 10.969-6 10.969s-6-6.469-6-10.969c0-3.328 2.672-6 6-6s6 2.672 6 6z" />
    </svg>
  ),
  fiskeTur: (
    <svg viewBox="0 0 290 290">
      <g>
        <path
          d="M235.7,46.1c11.8,0,21.4-9.7,21.4-21.6c0-12-9.6-21.6-21.4-21.6c-11.8,0-21.4,9.7-21.4,21.6
C214.3,36.4,223.9,46.1,235.7,46.1z"
        />
        <path
          d="M271.5,140.3l-6.8-64.6c0,0,0.1-1.6-0.4-3.9c0,0,0-0.1,0-0.1c-0.3-4.4-2.7-8.9-4.8-12.1c-0.6-1.2-1.5-2.5-2.8-3.8
c-0.1-0.1-0.2-0.2-0.2-0.2l0,0c-2.7-2.6-7-4.9-13.8-4.5c-7.9,0.4-12.1,3.7-14.4,6.8l0,0c0,0,0,0,0,0c-1.1,1.5-1.7,3-2,4
c-0.7,1.4-1.5,2.8-1.8,3.3c0,0,0,0,0,0L202,98.8l-33.5-14c0,0-7.2-4.4-13.2,2.6c-0.4,0.5-0.7,1-1,1.5
c-28.9-30.5-55.8-50.3-75.5-62.4C48.9,8,28.9,2.7,28.1,2.5c-2.6-0.7-5.2,0.9-5.9,3.5c-0.7,2.6,0.9,5.2,3.5,5.9c0.1,0,2,0.5,5.5,1.8
l53.4,99.2c-5.1,1.8-10.1,5-15,8.4c-4,2.8-7,5.2-10.8,8.6c-6.5,6.8-15.7,19.5-20.3,33c-6.7,2.8-15.9,8.2-22.2,18.1l-0.1,0.1l0,0.2
c0.3,6.1,2.1,12.1,3.1,14.7l3,7.7l0.5-0.3c1.2-0.6,2.3-1.4,3.4-2.2c1.7-1.2,3.5-2.5,5.4-2.9c0.1,0,0.2,0.1,0.2,0.2
c0.1,0.2,0.1,0.4,0.1,0.6l0,0.1c-0.7,8.3,1,17.2,5.3,28.2c3.5,8.9,10.2,15.5,20.4,20.2c4.9,1.7,10.5,3.3,16.2,3.3
c1.3,0,2.6-0.1,3.9-0.3c4.9-0.7,8.8-4,12.6-7.2c1.3-1.1,2.7-2.3,4.1-3.3c1.6-0.3,3.3,0.1,5.1,0.4c3.1,0.6,6.4,1.3,9-1.6l0.1-0.2
c1.6-1.8,3.3-3.7,4-6.3c0.1-0.8-0.1-1.5-0.7-2.1c-1.4-1.4-4.7-1.9-6.9-1.5c-0.5,0.1-0.8,0.3-1.1,0.4c-0.3,0.2-0.5,0.3-0.7,0.3
c-0.1-0.9,0.5-1.7,1.2-2.5c0.2-0.2,0.3-0.4,0.5-0.6c5.4-6.4,13.3-11.4,20.4-13.1c5.8-0.8,18.1,3.6,18.2,3.7l1.5,0.5l-0.8-1.3
c-7.8-12.8-13.4-27.1-16.1-41.4l-0.1-0.7l-0.7,0.4c-2.5,1.4-3.9,3.8-4.8,5.8c-0.8,1.7-1.6,3.3-2.3,5c-3.2,6.9-6.5,14-10.7,20.1
c-3.9,5.3-10.8,11.1-17.4,10.4c-3-0.5-5.4-3.4-5.5-6.7c0.3-2.1,0.6-4.3,1-6.7c0.7-4.3,1.5-8.8,1.5-13c0.1-4.3,0.3-5.3,0.5-6.1
c0.3-1.2,0.5-1.9,0.1-8.5c0.1-0.4,0.1-1,0.2-2.2c0.1-1.1,0.2-3.2,0.4-4.1l0.1,0.1c1.5,1,1.5,1,2.5,2.2l0.6,0.8l0.1,0.1
c1.3,0.9,3.2,1.6,5.7,2.2l0.6,0.1l0.1-1.4c0.4-3.5,0.5-5.3-1.5-11.1c-0.7-1.9-2.3-2.9-3.9-3.9c-3-1.9-5.7-3.5-1-11.4
c5-8.4,9.3-17.5,7.9-26.7c-0.3-1.2-0.7-2.7-2-3.3l-0.3-0.1l-0.8,0.7l0,0.2c-0.1,2.5-0.9,5.5-2.4,8.2l-5.5,5.6
c-0.8,1-1.3,2.2-1.9,3.3c-1,2.1-2,4.1-4,4.9c0,0-0.1,0-0.1,0c-0.5-0.3-0.7-0.4-0.7-0.7c1.2-7.8,4-14.8,7.9-19.7
c0.3-0.5,0.6-1,0.9-1.5c1.5-2.3,2.7-4.2,1.5-5.4l-0.1-0.1l-0.2,0c-1.5-0.1-2.9,0-4.4,0.2L37.9,16.2C46.4,19.7,59,25.6,74.2,35
c22.5,13.9,54.6,38.1,88.4,77.6c-1.2-0.9-2.6-1.6-4.1-2.1c-7.2-2.2-14.8,2-17,9.3c-2.2,7.3,1.8,15,9,17.2c7.2,2.2,14.8-2,17-9.3
c1.1-3.6,0.7-7.3-0.9-10.4c4.9,5.9,9.9,12.2,14.8,18.7c1,1.3,2.4,1.9,3.9,1.9c1,0,2-0.3,2.9-1c2.1-1.6,2.6-4.7,1-6.8
c-8.1-10.7-16.2-20.6-24.1-29.6l35.8,20.1c2,1.8,5.1,2.3,10,0.4l10-9.4l-1.4,21.6c0,0-1.2,25.9-1.4,34.5l-15.8,35.3
c-0.3,0.5-0.5,1.1-0.6,1.7c-0.6,1.3-1,2.8-1.2,4.4l-3.7,61.7c-0.6,14.3,8.1,13.2,8.1,13.2c6.9,1.6,9.4-4.3,10.2-11.1l8.7-56.7
c0.5-0.7,1-1.6,1.5-2.4l18.1-29.9l2.1,29.4c0,0.4,0,0.7,0.1,1.1l6.7,60.8c1.4,14.3,10,12.1,10,12.1c7,0.7,8.7-5.5,8.6-12.3
l0.6-60.6c0-0.5-0.1-1-0.1-1.5l2.2-40.8C273.4,171.9,275,160.1,271.5,140.3z M81.3,125.3c-1,1.5-3,1.7-4.3,0.6
c-1.3-1.1-1.6-3.2-0.5-4.6c1-1.5,3-1.7,4.3-0.6C82.1,121.8,82.4,123.8,81.3,125.3z"
        />
      </g>
    </svg>
  ),
  fotTur: (
    <svg viewBox="0 0 290.1 290.3">
      <g>
        <g>
          <path d="M189.8,23.2c0,12.8-10.3,23.1-23.1,23.1S143.6,36,143.6,23.2s10.3-23.1,23.1-23.1C179.3,0,189.8,10.5,189.8,23.2z" />
          <path d="M130.1,48.1c0,0-15.6-9.9-29.7-2.1C87.5,53,74.1,95.2,77.7,113.1c2.8,14.2,22.6,17.6,22.6,17.6L130.1,48.1z" />
        </g>
        <path
          d="M229.9,137l-36.3-28l-18.1-30.4c0-0.1,0-0.1,0-0.2c0.3-21.3-10.6-25.2-10.6-25.2c-4.3-2.3-19.6-8.7-25.2-0.3
c-4.9,7.4-28.3,79.1-29.5,83.6c-1.4,5.1-0.6,14.3,0.6,28.7c0.2,2.4-5.5,46.5-7.1,52.9c-3.7,14.7-11.4,57.7-11.7,59
c-2.8,12.8,17.3,18,21.6,4.3c1.7-5.8,15.4-45.8,30.1-93.4c0.2-0.6,27.3,40.7,28.1,41.9s12.3,49.6,12.4,50.2
c4.6,15.1,24.2,13,21-5.8c-1.5-8.9-7.2-49.9-11.5-63.5c-2.1-6.4-33.1-57.5-32.5-60c0.5-2.3,5-26.2,7.3-38.6l14.6,15
c2.2,1.5,38.7,22.4,38.7,22.4C228.7,155.1,238.7,144.8,229.9,137z"
        />
      </g>
    </svg>
  ),
  padleTur: (
    <svg viewBox="0 0 290 290">
      <g>
        <path
          d="M70.5,45.4c12.5,0.8,23.2-8.7,24-21.3c0.8-12.5-8.7-23.2-21.3-24C60.8-0.7,50,8.8,49.2,21.4C48.5,33.8,58.1,44.6,70.5,45.4
     z"
        />
        <path
          d="M179.4,114.2c-0.2-1-11.4,1.3-12.3,0L144.7,78c-16.8-28.8-46.4-39-54.7-33.5h-0.1L52.1,68.6l-28,5.6C21.2,75,7,76,5.8,78.3
     C1,87,17,87.3,17,87.3l24.7,31.5c-23.2,0.1-26.5,0.2-26.5,0.2l0.9,52.4c0,0,24.1-0.2,68,0.1l27.6,32c5,14.8,5.8,19.4,15.4,32.4
     c9.4,12.8,44.9,53.6,48.1,54.1c0.7,0.1,17.4-13.5,17-14.4c-1.3-4.6-40.2-52.2-44.5-56.3c-12.7-12.3-18.2-15-29.4-21.4
     c-0.2-0.1-14-15.4-24-26.5H96c101,1.1,132.1-5.2,134.4-6.1c11.2-4.4,14.7-7.7,23.7-15.9c25.6-23.3,31.1-40.2,31.1-40.2
     C285,101.3,215.8,113.9,179.4,114.2z M51.9,118.7L27.1,86.9c0,0,19.4,0.3,32.2-2.2c7.5-1.5,16.8-4.5,16.8-4.5
     c0.2-0.2,10,13.3,11.2,15.3l11.6,22.3C83.3,119.5,64.2,118.6,51.9,118.7z"
        />
      </g>
    </svg>
  ),
  sykkelTur: (
    <svg viewBox="0 0 290.6 291">
      <path
        d="M0,180.6c0,32.2,26.1,58.4,58.3,58.4c30,0,54.7-22.7,57.9-51.9h7.6c2.2,4.4,6.7,7.4,11.9,7.4c7.3,0,13.3-5.9,13.3-13.3
   c0-0.8-0.1-1.6-0.2-2.4l54.8-62.5l3.7,11.7c-19.8,9.3-33.7,29.4-33.7,52.8c0,32.2,26.1,58.4,58.3,58.4S290,213,290,180.7
   c0-32.2-26.1-58.4-58.3-58.4c-3.9,0-7.7,0.3-11.4,1.2l-19.6-62.3c-2.1-6.1-3.1-9.2-6.1-9.2H172c-3.5,0-6.2,3.5-6.2,7.7
   s2.8,7.7,6.2,7.7h16.1l4.8,15.5c-0.1,0-0.2,0.1-0.5,0.1l-76.9,23.9l-10.4-33h7.5c4.3,0,7.7-3.5,7.7-7.7c0-4.3-3.5-7.7-7.7-7.7h-28
   c-4.3,0-7.7,3.5-7.7,7.7c0,4.3,3.5,7.7,7.7,7.7h7.2l2.9,9c-0.2,0.3-0.5,0.8-0.6,1.2l-17.6,41.2c-5.7-1.8-11.8-2.9-18.1-2.9
   C26.1,122.2,0,148.4,0,180.6z M210.8,139.4l13.5,42.9c0.9,3.1,4.7,4.7,8.4,3.6c3.7-1.2,5.9-4.6,4.8-7.7L224,135
   c2.5-0.5,5.1-0.7,7.7-0.7c25.5,0,46.1,20.6,46.1,46.1s-20.6,46.1-46.1,46.1s-46.1-20.6-46.1-46.1
   C185.6,162.6,195.9,147.1,210.8,139.4z M100.6,101.7l22.8,72.7h-7.2c-2-18.7-12.7-34.6-28-43.8L100.6,101.7z M103.9,174.3H69.2
   l14-32.5C94.4,149,102.1,160.7,103.9,174.3z M197.3,103.5l-57.1,65.2c-1.4-0.5-2.9-0.8-4.5-0.8c-0.3,0-0.6,0-0.9,0l-14.9-47.5
   l76.9-23.9c0.1,0,0.3-0.1,0.5-0.2l1.8,5.8C198.4,102.5,197.8,102.9,197.3,103.5z M12.1,180.6c0-25.5,20.6-46.1,46.1-46.1
   c4.6,0,9.1,0.7,13.3,2L54,177.2c-0.3,0.7-0.5,1.4-0.6,2.1c0,0.2-0.1,0.5-0.1,0.7v0.1c0,0.2,0,0.5,0,0.6c0,1.2,0.3,2.2,0.8,3.1
   c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2c0.6,0.9,1.5,1.7,2.5,2.2c0.9,0.5,2,0.6,2.9,0.3h44.1c-3.1,22.5-22.4,39.7-45.7,39.7
   C32.8,226.7,12.1,206.1,12.1,180.6z"
      />
    </svg>
  ),
  skiTur: (
    <svg viewBox="0 0 289.8 290">
      <g>
        <path
          d="M62.1,240.8H-0.7v10.7H172l-8.4,22l5.5,2.1l9.2-24.2h82.1C278.6,251.3,286,236,286,236s8.1-20.4-2.6-9.3
     c-11.7,12.3-14.8,13.2-22.9,14h-78l56.5-147.8h0.5c4.3,0.6,8.3-2.6,8.9-7.1c0.7-4.6-2.3-8.8-6.6-9.3l-62.9-6.9
     c-0.2-6-2.8-12.1-10.3-15.3c0,0-14.8-7.3-25.4,11.6l-24.8,46.8c-3.2,7.6-6.4,14.8-7.6,21.1L-1.1,191l2.6,5.1l108.6-55.6
     c0,0.5,0.1,0.9,0.1,1.4l-8.7,29.2c-0.3,1-0.7,2.1-0.8,3l-39.3,48.3c-4.8,5.6-7.7,12-1.4,16.5C60.3,239.2,60.9,240.1,62.1,240.8z
      M76.9,236.2l47-47.8c1.1-1.4,2.1-2.7,2.7-4.2c0.3-0.5,0.7-1,0.9-1.7l8.4-19.4l19.5,21.1l-11,44.2c-1.4,5.4-0.9,10.7,5.1,12.5H70.7
     C72.6,240,74.6,238.5,76.9,236.2z M176.3,240.8h-17.3c1.9-1.1,3.9-3.3,5.4-7.3l17.5-51.7c0.2-1,0.3-1.9,0.3-3
     c0.8-2.3,0.8-4.4-0.7-6.3l-25.6-39.2c-0.2-0.2-0.5-0.5-0.7-0.7l17.1-40.9l60.4,1.1L176.3,240.8z"
        />
        <path d="M182.6,52.4c-12.2,0-22.1-9.9-22.1-22.1s9.9-22.1,22.1-22.1c12.2,0,22.1,9.9,22.1,22.1C204.7,42.5,194.8,52.4,182.6,52.4z" />
      </g>
    </svg>
  ),
  annenTur: (
    <svg viewBox="0 0 290 290">
      <g id="friluftsliv">
        <path
          d="M108.1,219.8l16.6,1.2l-0.6-18.4c-5.9-2-12.2-3-19-3l-16.3,1.2l-11.6,2.4v-19.8l16.3-0.9l11.6-2.4
c7.7-2.2,11.9-3.6,12.7-4.1c-12.2-2.6-21.7-7.5-28.3-14.8c-6.6-7.3-10.7-12.8-12.3-16.6c18,0,28.7-2.9,32.3-8.6l-0.6,0.6l-8.6-2.4
c-6.7-2-12.8-6.6-18.4-13.9c-6.3-7.3-11.2-18.7-14.5-34.1c-1.2,4.7-2.8,9.7-4.9,14.8c-2.1,5.1-4.5,10.3-7.3,15.4
c-6.9,13-17.6,19.6-32,19.6l7.7,5.3c3.6,1.8,6.8,2.7,9.8,2.7c0.6,0,1.7,0.2,3.3,0.6h5.9H57c-3.2,4.7-8,10.5-14.5,17.2
s-16,11.3-28.4,13.6c1.6,1.2,6.1,2.8,13.5,4.9c7.4,2.1,16.8,3.1,28.3,3.1l-0.6,25.5c-3,0.8-9.4,3.2-19.3,7.1
c-10.9,5.7-22.6,13.6-35.3,23.7V264c8.3-7.7,22-17,41-27.8C61,225.2,83,219.8,108.1,219.8z"
        />
      </g>
      <g>
        <g>
          <path d="M191.4,0c12.8,0,23.1,10.3,23.1,23.1s-10.3,23.1-23.1,23.1s-23.1-10.3-23.1-23.1C168.3,10.4,178.8-0.1,191.4,0z" />
          <path d="M257.8,130.6c0,0,19.8-3.4,22.6-17.6c3.6-17.9-9.8-60.1-22.7-67.1C243.6,38.1,228,48,228,48L257.8,130.6z" />
        </g>
        <path
          d="M136.3,149.5c0,0,36.5-20.9,38.7-22.4l14.6-15c2.3,12.4,6.8,36.3,7.3,38.6c0.6,2.5-30.4,53.6-32.5,60
c-4.3,13.6-10,54.6-11.5,63.5c-3.2,18.8,16.4,20.9,21,5.8c0.1-0.6,11.6-49,12.4-50.2s27.9-42.5,28.1-41.9
c14.7,47.6,28.4,87.6,30.1,93.4c4.3,13.7,24.4,8.5,21.6-4.3c-0.3-1.3-8-44.3-11.7-59c-1.6-6.4-7.3-50.5-7.1-52.9
c1.2-14.4,2-23.6,0.6-28.7c-1.2-4.5-24.6-76.2-29.5-83.6c-5.6-8.4-20.9-2-25.2,0.3c0,0-10.9,3.9-10.6,25.2c0,0.1,0,0.1,0,0.2
l-18.1,30.4l-36.3,28C119.4,144.7,129.4,155,136.3,149.5z"
        />
      </g>
    </svg>
  ),
  badeplass: (
    <svg viewBox="0 0 290 290">
      <g>
        <path
          d="M0,221.5c7.2,4.8,14.5,7.2,21.7,7.2c5.1,0,9.6-1.3,13.4-4l12.9-8.3c4.4-2.7,9-4,13.7-4c5.1,0,9.7,1.3,13.7,4l13.2,8.3
     c4.2,2.7,8.9,4,14,4c2.7,0,4.6-0.1,5.7-0.4c1.1-0.3,2.7-0.9,4.6-1.7c1.9-0.9,3.5-1.7,4.9-2.4c1.3-0.8,3.1-2,5.3-3.7
     c2.2-1.7,3.9-3,5.1-3.7c1.2-0.8,2.8-1.4,4.7-2c3-1.5,6.6-2.3,10.6-2.3c6.3,0,13.3,2.7,21,8.2c7.7,5.4,14.3,8.2,19.6,8.2
     c3.6,0,7.1-0.6,10.3-1.7c3.2-1.5,6.6-3.7,10-6.6l10-5.7c2.7-1.5,6.2-2.3,10.6-2.3c5.3,0,10,1.3,14,4l13.4,8.3c4.4,2.7,9.1,4,14,4
     c7.1,0,12.4-0.9,16.2-2.6c3.7-1.7,6.1-3.2,7.3-4.6v30l-8,5.1c-4.2,2.1-9.3,3.1-15.4,3.1c-4.8,0-9.4-1.6-14-4.9l-13.4-8.6
     c-4.8-3.2-9.4-4.9-14-4.9c-5.1,0-9.9,1.6-14.3,4.9l-12.6,8.6c-4.8,3.2-9.4,4.9-14,4.9c-4.8,0-9.3-1.6-13.7-4.9l-13.4-8.9
     c-4.2-3-8.7-4.6-13.4-4.6c-4.6,0-9.3,1.5-14,4.6l-12.9,8.9c-4.8,3.2-9.4,4.9-14,4.9c-5.3,0-10-1.6-14-4.9c-1.9-1.1-3.9-2.4-6-3.9
     c-2.1-1.4-4.4-3.1-6.9-5c-5-3-9.6-4.6-14-4.6c-2.7,0-4.6,0.1-5.7,0.4c-1.1,0.3-2.8,0.9-4.9,1.9L40.6,251l-10,6.3
     c-2.9,1.7-5.8,2.6-8.9,2.6c-7.1,0-14.3-2.8-21.7-8.3V221.5z M143,197.5c-5.1,0-11.9,2.4-20.3,7.2c-7.4,5.1-14.3,7.7-20.6,7.7
     c-5.1,0-12.2-2.6-21.2-7.7c-3.8-2.1-7.4-3.8-10.7-5.1c-3.3-1.3-6.1-2-8.4-2c-1.5,0-3.3,0.5-5.4,1.4l-4,1.1
     c0-10.7,2.2-21.6,6.6-32.9c4.4-11.2,9.9-20.6,16.6-28C82.2,131.7,89,128,96.1,128c20.6,7.4,36.4,11.2,47.5,11.2
     c11.6,0,27.6-3.7,48-11.2c6.7,0,13.9,3.7,21.7,11.2c6.7,7.6,12.2,17.1,16.4,28.3c4.3,11.3,6.4,22.1,6.4,32.6l-6-1.7l-5.1-0.9
     c-5.1,0-11.8,2.4-20,7.2c-8,5.1-15,7.7-20.9,7.7c-5.1,0-11.6-2.6-19.4-7.7C156.3,199.9,149.1,197.5,143,197.5z M104.4,78.8
     c0-8.6,1.7-16.6,5.1-24c4-7.8,8.9-13.8,14.6-18c2.9-2.1,5.9-3.7,9.2-4.9c3.2-1.1,6.9-1.7,10.9-1.7c7.6,0,14.4,2.1,20.3,6.3
     c5.9,4.2,10.7,10.3,14.3,18.2c3.6,7.9,5.4,16,5.4,24.2c0,13.7-3.9,25.4-11.7,34.9c-7.8,9.5-17.3,14.3-28.3,14.3
     c-10.1,0-19.4-4.9-28-14.6C108.3,103.5,104.4,91.9,104.4,78.8z"
        />
      </g>
    </svg>
  ),
  gapahuk: (
    <svg viewBox="0 0 288.5 288.7">
      <g>
        <path
          d="M285.5,0L3,188.2V290h282.6v-29.5l-33.5-0.7c9.3,0.2,16.1-7.4,7.8-19.5l-20.3-34.7c14.4-1.3,19.5-3.9,21.1-9.3
  c0,0,2.3-7.9-5.9-12.4l-11.7-1.1c-10.4-1.3-20-1.7-20-1.7s-8.5-12.9-12-17.7c-12.9-18.3-23.3-18.3-23.3-18.3
  c-7.9-3.4-23.7,4.4-35.2,13.2c-11.5,9-21.7,20.3-30.5,34c-8.9,13.7-13.2,27.4-13.2,41.2c0,18.6,10.4,25.4,14,27.1H33.2l-0.1-57.7
  L285.5,35.2V0z M214.9,226.9l31.9,33.6l-84.6,0.1L214.9,226.9z"
        />
        <path
          d="M210.9,101.2c-13.8,4.6-21.4,19.7-16.6,33.6c4.6,13.8,19.7,21.4,33.6,16.6c13.8-4.6,21.4-19.7,16.6-33.6
  C239.9,104,224.9,96.5,210.9,101.2z"
        />
      </g>
    </svg>
  ),
  tilrettelagt: (
    <svg viewBox="0 0 290 290">
      <g>
        <path
          d="M64.8,159.8c-10.7,14.2-16.1,27.9-16.1,40.9c0,15.4,6.2,28.4,18.5,39.2S93.3,256,108.4,256c26.4,0,46-15.1,58.8-45.3
l14.4,45.3c-13.9,22.6-37.4,34-70.5,34c-26.1,0-49.8-7.9-71-23.7S8.2,230.1,8.2,205.1c0-44.1,17.6-75.3,52.7-93.6L64.8,159.8z
M121.8,68.8l4.4,70.5h77.3l32.1,87.2l35.7-10.6l10.5,35.7L211.5,273l-32.7-95.4H88.8L79.6,24.4c0-6.1,3.5-11.6,10.5-16.5
c4.1-2.6,8.3-4.6,12.8-5.9c4.5-1.3,10.1-2,16.8-2c10.2,0,19.4,4.1,27.9,12.2c8.4,8.1,12.6,17.1,12.6,27
C160.2,56.9,147.4,66.8,121.8,68.8z"
        />
      </g>
    </svg>
  ),
  utleiehytte: (
    <svg viewBox="0 0 100 100">
      <path d="M45.6,57.5c-0.7,2.9-2.3,5.1-4.9,6.7c-2.6,1.6-5.6,2.4-9,2.4c-4.5,0-8.6-1.4-12.2-4.3s-5.4-6.8-5.4-11.7c0-4,0.9-7.4,2.6-10.2c1.7-2.8,4-4.9,6.8-6.5c2.9-1.3,5.8-1.9,8.7-1.9c3.4,0,6.3,0.8,8.8,2.3c2.2,1.5,3.8,3.8,4.7,6.9h6.7l7,7.4l7-7.4l7,7.4l7-7.4l6.9,9.4l-6.9,7H45.6z M20.3,50.1c0,1.4,0.6,2.7,1.7,3.9c0.9,1.1,2.1,1.6,3.8,1.6c1.3,0,2.6-0.5,3.8-1.6l1.1-1.7l0.4-2.2c0-1.5-0.5-2.8-1.4-3.8c-1.1-0.9-2.4-1.4-3.8-1.4c-1.6,0-2.9,0.5-3.9,1.5S20.3,48.7,20.3,50.1z" />
    </svg>
  ),
  apentHusvaere: (
    <svg viewBox="0 0 291.5 291.7">
      <polyline
        points="145.8,4 0.8,121.2 0.8,140.5 28.2,140.5 28.2,287.7 102.8,287.7 102.8,130.6 188.9,130 188.9,287.7 264.1,287.7
263.4,140.5 290.7,140.5 290.7,121.2 145.9,4 "
      />
    </svg>
  ),
  infotavle: (
    <svg viewBox="0 0 100 100">
      <path d="M38.7,21.2c0-2.8,1.1-5.3,3.2-7.4c2.1-2.1,4.7-3.2,7.6-3.2c2.8,0,5.3,1,7.6,3.1c2.1,2.2,3.1,4.7,3.1,7.6c0,2.8-1,5.3-3.1,7.6c-2.2,2.1-4.7,3.1-7.6,3.1c-3,0-5.5-1.1-7.7-3.2S38.7,24.1,38.7,21.2z M30.1,87.6v-6.2h6.2V42.3h-6.2V36h32.1v45.4h6.2v6.2H30.1z" />
    </svg>
  ),
  bru: (
    <svg viewBox="0 0 100 100">
      <path d="M70.7,76.2L69,77.3v-3.4L68.8,69c0-2.3,0.8-4.1,2.3-5.4l2-1.3l2.7-1.2c2-0.5,3.1-0.9,3.4-1.1c2.8-2.4,5.5-4.3,8.3-5.5l3.3-1.5l2.8-1.1v26.5c-0.2,0.4-0.9,0.9-2.1,1.4s-2.9,0.8-4.9,0.8c-1.7,0-3.8-0.9-6.2-2.6c-2.4-1.7-4.5-2.6-6.2-2.6C72.7,75.4,71.5,75.7,70.7,76.2z M6.7,82.3c2.5,1.5,4.6,2.2,6.5,2.2c0.9,0,1.9-0.2,3-0.5l3.1-2l3.1-1.8c0.8-0.5,1.8-0.8,2.9-0.8c1.3,0,2.4,0.2,3.4,0.6l3.2,2.1c1.3,1,2.4,1.6,3.1,1.8c0.7,0.4,1.6,0.5,2.6,0.5l1.7-0.1l1.6-0.6c0.5-0.2,1-0.5,1.5-0.8c0.4-0.3,0.9-0.7,1.5-1.2l3-1.8c1.2-0.4,2.3-0.6,3.1-0.6c2,0,4.1,0.9,6.3,2.6c2.4,1.7,4.4,2.6,6,2.6c1,0,2-0.2,3-0.5l3.1-2l3.3-1.8c0.7-0.5,1.7-0.8,2.9-0.8c1.8,0,3.8,0.9,6.2,2.6c2.4,1.7,4.5,2.6,6.2,2.6c2.2,0,3.9-0.3,4.9-0.8s1.8-1,2.1-1.4v9.1c-0.4,0.4-1.2,0.8-2.6,1.4c-1.3,0.6-2.8,0.9-4.5,0.9c-0.9,0-2-0.4-3.3-1.1l-1.7-0.9l-1.6-1.1l-2.6-1.8c-1-0.4-2.1-0.5-3.3-0.5c-0.8,0-1.4,0.1-1.7,0.2c-0.3,0-0.8,0.2-1.4,0.5l-1.6,1l-2,1.4l-2.9,1.8c-0.7,0.4-1.6,0.5-2.6,0.5c-1.3,0-2.8-0.5-4.2-1.4l-4-2.7c-1.3-0.8-2.7-1.2-4.1-1.2s-2.8,0.4-4.1,1.2l-4,2.7c-1.3,0.9-2.7,1.4-4.1,1.4c-1.5,0-2.8-0.5-4-1.4c-1.2-0.6-2.6-1.6-4.1-2.7c-1.3-0.8-2.7-1.2-4.1-1.2c-0.9,0-1.5,0.1-1.8,0.2c-0.3,0-0.9,0.2-1.8,0.7c-0.9,0.4-1.8,1-2.6,1.7L16,92.6c-1.1,0.7-2,1.1-2.8,1.1c-2.3,0-4.5-0.8-6.5-2.3V82.3z M66.9,53.9l-17.2,0.7c-7.5,0-15.1-0.4-22.7-1.1c-7.7-0.7-13.3-1.3-17-1.8v-7.9l17.2,1.7l11.9,1l10.6,0.3c1.1,0,3-0.1,5.6-0.2c2.6-0.1,4.1-0.2,4.5-0.2c1.8,0,3.9-0.1,6.5-0.4c2.6-0.3,4.5-0.5,5.7-0.6c4,0,7.7-0.2,11-0.6l7.7-1.1v7.7l-8.6,1.1L66.9,53.9z M6.7,78.5V52c1.3,0,3.6,0.8,6.7,2.4c3.1,1.4,5.5,3.3,7.1,5.5c3.8,4.8,5.6,9.8,5.6,15c-2,0.4-3.4,0.9-4.3,1.5l-3.3,2.1l-2.9,1.8l-0.8,0.3l-1.7,0.1C11.1,80.7,8.9,80,6.7,78.5z" />
    </svg>
  ),
  attraksjon: (
    <svg viewBox="0 0 290 290">
      <g>
        <path
          d="M91.4,167.7V122H63c-16.1,0-30.4-6.1-42.8-18.4C7.7,91.4,1.5,77.5,1.5,61.8c0-15,5.6-29,16.9-42.2C29.6,6.6,43.6,0,60.3,0
     c15.9,0,30.3,6.1,43.2,18.2c12.9,12.1,19.3,26.5,19.3,43v28.4h45.3V61c0-16.9,6.1-31.3,18.2-43.1C198.5,5.9,212.7,0,229,0
     c15.2,0,28.9,6,41.2,18.1c12.2,12.1,18.4,26.3,18.4,42.7c0,16.2-5.8,30.4-17.4,42.7c-11.6,12.3-25.4,18.4-41.5,18.4h-29.1v45.6
     h29.1c16.3,0,30.2,6.1,41.7,18.2c11.5,12.2,17.2,26.5,17.2,43.1c0,15.7-5.9,29.8-17.7,42.3C259,283.8,245.1,290,229,290
     c-11,0-20.9-2.5-29.8-7.6c-8.8-5.1-16.2-12.3-22.2-21.8c-6-9.5-8.9-19.9-8.9-31.4V202h-45.3v26.5c0,11-2.9,21.3-8.6,30.8
     c-5.8,9.5-13.4,17-22.9,22.5c-9.5,5.5-19.5,8.3-29.9,8.3c-17.1,0-32-7.1-44.9-21.2c-10-11.3-15-24.3-15-39.1
     c0-10.8,2.6-20.9,7.8-30.3c5.2-9.4,12.5-17,22-22.9s19.9-8.8,31.5-8.8H91.4z M38.3,45.1c-3.3,4.7-5,10.1-5,16.4
     c0,7.1,3.1,13.7,9.4,19.7c6.2,5.6,12.9,8.4,20.1,8.4h28.8V60.2c0-8.9-2.7-16-8.2-21.4c-5.5-5.4-12.1-8-19.9-8
     C52.2,30.8,43.8,35.5,38.3,45.1z M45.6,253.2c6.5,4.2,12.4,6.4,17.7,6.4c7.6,0,14.2-3.3,19.7-9.9c5.6-6.6,8.4-13.3,8.4-20.2V202
     H62.7c-9.4,0-16.7,2.7-22.1,8c-4.9,5.6-7.4,12-7.4,19.4C33.2,240,37.4,247.9,45.6,253.2z M122.8,122v45.6h45.3V122H122.8z
      M200.6,60.8v28.8h28.8c8.2,0,15.2-3.1,20.9-9.2c5.7-6.1,8.5-12.9,8.5-20.2c0-5.3-1.8-11.1-5.4-17.4c-5.4-8-12.9-12-22.7-12
     c-7.4,0-14.2,2.7-20.6,8.2C203.7,44.4,200.6,51.7,200.6,60.8z M249.5,253.3c6.2-5.5,9.3-12.7,9.3-21.5c0-8.2-2.5-15.1-7.6-20.8
     c-4.6-6-12-8.9-22.2-8.9h-28.4v27.1c0,9.9,3.1,17.5,9.3,22.8c2.9,2.4,6.1,4.3,9.6,5.6c3.5,1.3,7.4,2,11.6,2
     C238.9,259.6,245.1,257.5,249.5,253.3z"
        />
      </g>
    </svg>
  ),
  rasteplass: (
    <svg viewBox="0 0 288.5 288.7">
      <path
        d="M277.4,140.2H214l-25.1-59.9h36.2c5.8,0,10.4-5.6,10.4-12.4s-4.7-12.4-10.4-12.4H64.5c-5.8,0-10.4,5.6-10.4,12.4
s4.7,12.4,10.4,12.4h36.7l-25.6,59.9H11.1c-6.5,0-11.8,5.3-11.8,11.8s5.3,11.8,11.8,11.8h54.4l-29.6,69.4h29.8L94,163.9h101.2
l27.8,69.4h29.8l-29-69.4h53.6c6.5,0,11.8-5.3,11.8-11.8S283.9,140.2,277.4,140.2z M103.5,140.2l24.4-59.9h33.6l24.1,59.9H103.5z"
      />
    </svg>
  ),
  batutsettplass: (
    <svg viewBox="0 0 290 290">
      <g>
        <path
          d="M184.2,214.3c3.9,0,8.5-1.5,13.8-4.4l13.2-7.6c4.1-2.9,8.7-4.4,13.8-4.4c3.9,0,8.5,1.5,13.8,4.4l13.8,8.5
c4.5,2.7,9.1,4.1,13.8,4.1c7.8,0,13.4-0.9,16.6-2.6c3.2-1.8,5.5-3.3,6.9-4.7v30.3c-1.2,1.2-4,2.7-8.4,4.7c-4.4,2-9.5,2.9-15.1,2.9
c-3.3,0-7-1.2-10.9-3.5c-2-1-3.8-2-5.4-2.9s-3.5-2.3-5.4-3.8l-8.8-5.9c-3.3-1.2-7-1.8-10.9-1.8c-2.5,0-4.4,0.1-5.6,0.4
c-1.2,0.3-2.7,0.9-4.7,1.9c-2,1-3.7,2-5.3,3.1c-1.6,1.1-3.8,2.7-6.8,4.8l-9.7,5.9c-2.4,1.2-5.3,1.8-8.8,1.8V214.3z M160.7,107.1
c-2.2-7.1-6.4-15.2-12.8-24.5s-16.8-17-31.3-23.1L96.4,86.8L160.7,107.1z M234.8,181.7L41.4,134.1c-11-3.5-20.6-13.5-28.8-30
c-4.1-8.2-7.2-16.3-9.4-24.1S0,64.6,0,57.1l84.3,25.3l28.8-37.9c5.9,2.5,11.6,5.6,17.2,9.1c5.6,3.5,10.4,7.1,14.5,10.9
c8.2,7.6,14.5,14.2,18.8,19.7c1.6,2.5,3,5.2,4.4,7.9c1.4,2.7,2.7,5.6,4.1,8.5l2.9,9.4l72.9,22.3L234.8,181.7z M46.4,167.3L0,155.3
v-20.6l188.9,48.2l-4.7,18.8l-83.7-21.2c3.5,4.1,5.3,10.8,5.3,20c-2,12.7-5.8,21.9-11.5,27.6c-7.6,7.6-16.8,11.5-27.6,11.5
c-10.4,0-19.5-3.8-27.3-11.5c-7.8-7.6-11.8-16.8-11.8-27.6c0-10.4,3.8-19.7,11.5-27.9C42,169.1,44.5,167.3,46.4,167.3z"
        />
      </g>
    </svg>
  ),
  havn: (
    <svg viewBox="0 0 290 290">
      <path
        d="M216.6,157.2c0.7-2.1,1.2-4.2,1.2-6.4c0.2-5.8-1.9-11.1-4.7-15.4c16.3,11.4,41.2,31.4,63.2,59.1c1.1,1.4,2.7,2.1,4.4,2.1
c1.2,0,2.5-0.4,3.5-1.2c2.4-1.9,2.8-5.5,0.9-7.9c-34.2-43.1-74.3-67.6-82.6-72.4l0.1-21.6l69.9,0.2l0.1-41l-69.9-0.2l0.1-42.1
L73.7,10l-0.1,42.1L3.7,51.9l-0.1,41l69.9,0.2l-0.1,29l-0.3-0.5c-0.6,0.5-15.7,11.9-15.1,26.9c0.2,6.6,3.5,12.6,9.4,18
c-4.9,4.7-11,12.4-10.7,21.6c0.2,6.6,3.6,12.5,10,17.7c-4.8,4.8-10.3,12.2-10,21.2c0.3,8.5,5.8,16,16.3,22.2l-0.1,30.5l129.2,0.4
l0.1-28.2c10.9-6.3,16.6-13.9,16.9-22.6c0.3-8.9-5.2-16.4-10-21.2c6.4-5.2,9.8-11.1,10-17.7c0.3-9.3-5.7-17-10.7-21.6
c0.8-0.7,1.5-1.5,2.2-2.3c32.9,24,65.3,66.4,65.6,66.8c1.1,1.4,2.7,2.2,4.4,2.2c1.2,0,2.3-0.4,3.3-1.1c2.4-1.8,2.9-5.3,1.1-7.7
C283.6,224.8,250.9,182,216.6,157.2z M197.6,134.3c1.3,1.2,3.2,3.1,4.9,5.4c2.3,3,4.2,6.8,4.1,10.6c-0.1,2.9-1.6,5.7-4.1,8.4
c-1.4,1.5-3,2.9-5.1,4.3c-16.7,5.1-34.3,7.1-51.1,7.1c-26.6,0-51.2-4.7-67-8.6c-2.5-1.6-4.4-3.3-6-5c-2.5-2.7-4-5.5-4.1-8.4
c-0.2-3.8,1.8-7.7,4.2-10.8c1.2-1.7,2.6-3.1,3.8-4.3C96.7,138.5,154.2,151.9,197.6,134.3z M202.4,199c-0.4,0.4-0.8,0.7-1.3,1.1
c-18.1,6.3-37.4,8.7-55.8,8.7c-26.8,0-51.5-4.8-67.3-8.7c-1.9-1.2-3.5-2.3-4.8-3.5c-3.3-2.8-5.1-5.8-5.2-8.7
c-0.2-3.9,2.4-7.9,5.3-11.1c1.7-1.8,3.4-3.4,4.8-4.5c21.2,5.8,76.4,17.8,118.4,0.8l-0.2,0.3c1.4,0.9,3.8,2.9,6.2,5.5
c2.9,3.2,5.6,7.3,5.4,11.3C207.7,193.1,205.8,196.1,202.4,199z M75.9,237.6c-1.1-0.7-2-1.5-2.8-2.3c-3.2-2.9-5-5.8-5.1-8.8
c-0.2-4,2.3-8,5.2-11.2c1.9-2.2,3.9-3.9,5.4-5.1c18.8,5.4,75.3,18.8,118.8,2.3c1.4,1.1,3.2,2.7,5,4.6c3,3.3,5.7,7.4,5.5,11.6
c-0.1,3.1-2.1,6.2-5.6,9.2c-1,0.9-2.3,1.8-3.6,2.6c-16.5,5-33.9,6.9-50.5,6.9C118.3,247.6,91.1,241.7,75.9,237.6z"
      />
    </svg>
  ),
  teltplass: (
    <svg viewBox="0 0 100 100">
      <path d="M38.9,77.4l10.8-15.8l10.5,15.8h8.6l-19.1-27l-18.9,27H38.9z M87.4,82.3H12.8L46.5,34l-7.6-10.7h7.6l3.3,5.2l3.6-5.2h6.9L53.3,34L87.4,82.3z" />
    </svg>
  ),
  heartOutline: (
    <svg viewBox="0 0 28 28">
      <path d="M26 9.312c0-4.391-2.969-5.313-5.469-5.313-2.328 0-4.953 2.516-5.766 3.484-0.375 0.453-1.156 0.453-1.531 0-0.812-0.969-3.437-3.484-5.766-3.484-2.5 0-5.469 0.922-5.469 5.313 0 2.859 2.891 5.516 2.922 5.547l9.078 8.75 9.063-8.734c0.047-0.047 2.938-2.703 2.938-5.563zM28 9.312c0 3.75-3.437 6.891-3.578 7.031l-9.734 9.375c-0.187 0.187-0.438 0.281-0.688 0.281s-0.5-0.094-0.688-0.281l-9.75-9.406c-0.125-0.109-3.563-3.25-3.563-7 0-4.578 2.797-7.313 7.469-7.313 2.734 0 5.297 2.156 6.531 3.375 1.234-1.219 3.797-3.375 6.531-3.375 4.672 0 7.469 2.734 7.469 7.313z" />
    </svg>
  ),
  heart: (
    <svg viewBox="0 0 512 512">
      <path
        fill="currentColor"
        d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
      />
    </svg>
  ),
  close: (
    <svg viewBox="0 0 24 24">
      <g fill="currentColor">
        <path d="M6.34,4.93,12,10.59l5.66-5.66,1.41,1.41L13.41,12l5.66,5.66-1.41,1.41L12,13.41,6.34,19.07,4.93,17.66,10.59,12,4.93,6.34Z" />
      </g>
    </svg>
  ),
  eye: (
    <svg viewBox="0 0 32 32">
      <path d="M16 6c-6.979 0-13.028 4.064-16 10 2.972 5.936 9.021 10 16 10s13.027-4.064 16-10c-2.972-5.936-9.021-10-16-10zM23.889 11.303c1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303s-5.527-0.796-7.889-2.303c-1.88-1.199-3.473-2.805-4.67-4.697 1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 4.418 3.582 8 8 8s8-3.582 8-8c0-0.962-0.17-1.883-0.482-2.737 0.124 0.074 0.248 0.15 0.371 0.228v0zM16 13c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z" />
    </svg>
  ),
  eyeBlocked: (
    <svg viewBox="0 0 32 32">
      <path d="M29.561 0.439c-0.586-0.586-1.535-0.586-2.121 0l-6.318 6.318c-1.623-0.492-3.342-0.757-5.122-0.757-6.979 0-13.028 4.064-16 10 1.285 2.566 3.145 4.782 5.407 6.472l-4.968 4.968c-0.586 0.586-0.586 1.535 0 2.121 0.293 0.293 0.677 0.439 1.061 0.439s0.768-0.146 1.061-0.439l27-27c0.586-0.586 0.586-1.536 0-2.121zM13 10c1.32 0 2.44 0.853 2.841 2.037l-3.804 3.804c-1.184-0.401-2.037-1.521-2.037-2.841 0-1.657 1.343-3 3-3zM3.441 16c1.197-1.891 2.79-3.498 4.67-4.697 0.122-0.078 0.246-0.154 0.371-0.228-0.311 0.854-0.482 1.776-0.482 2.737 0 1.715 0.54 3.304 1.459 4.607l-1.904 1.904c-1.639-1.151-3.038-2.621-4.114-4.323z" />
      <path d="M24 13.813c0-0.849-0.133-1.667-0.378-2.434l-10.056 10.056c0.768 0.245 1.586 0.378 2.435 0.378 4.418 0 8-3.582 8-8z" />
      <path d="M25.938 9.062l-2.168 2.168c0.040 0.025 0.079 0.049 0.118 0.074 1.88 1.199 3.473 2.805 4.67 4.697-1.197 1.891-2.79 3.498-4.67 4.697-2.362 1.507-5.090 2.303-7.889 2.303-1.208 0-2.403-0.149-3.561-0.439l-2.403 2.403c1.866 0.671 3.873 1.036 5.964 1.036 6.978 0 13.027-4.064 16-10-1.407-2.81-3.504-5.2-6.062-6.938z" />
    </svg>
  ),
  fullscreen: (
    <svg viewBox="0 0 16 16">
      <path d="M2 5h-2v-4c0-0.552 0.448-1 1-1h4v2h-3v3z" />
      <path d="M16 5h-2v-3h-3v-2h4c0.552 0 1 0.448 1 1v4z" />
      <path d="M15 16h-4v-2h3v-3h2v4c0 0.552-0.448 1-1 1z" />
      <path d="M5 16h-4c-0.552 0-1-0.448-1-1v-4h2v3h3v2z" />
    </svg>
  ),
  fullscreenShrink: (
    <svg viewBox="0 0 16 16">
      <path d="M3 0h2v4c0 0.552-0.448 1-1 1h-4v-2h3v-3z" />
      <path d="M11 0h2v3h3v2h-4c-0.552 0-1-0.448-1-1v-4z" />
      <path d="M12 11h4v2h-3v3h-2v-4c0-0.552 0.448-1 1-1z" />
      <path d="M0 11h4c0.552 0 1 0.448 1 1v4h-2v-3h-3v-2z" />
    </svg>
  ),
  earth: (
    <svg viewBox="0 0 32 32">
      <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 30c-1.967 0-3.84-0.407-5.538-1.139l7.286-8.197c0.163-0.183 0.253-0.419 0.253-0.664v-3c0-0.552-0.448-1-1-1-3.531 0-7.256-3.671-7.293-3.707-0.188-0.188-0.442-0.293-0.707-0.293h-4c-0.552 0-1 0.448-1 1v6c0 0.379 0.214 0.725 0.553 0.894l3.447 1.724v5.871c-3.627-2.53-6-6.732-6-11.489 0-2.147 0.484-4.181 1.348-6h3.652c0.265 0 0.52-0.105 0.707-0.293l4-4c0.188-0.188 0.293-0.442 0.293-0.707v-2.419c1.268-0.377 2.61-0.581 4-0.581 2.2 0 4.281 0.508 6.134 1.412-0.13 0.109-0.256 0.224-0.376 0.345-1.133 1.133-1.757 2.64-1.757 4.243s0.624 3.109 1.757 4.243c1.139 1.139 2.663 1.758 4.239 1.758 0.099 0 0.198-0.002 0.297-0.007 0.432 1.619 1.211 5.833-0.263 11.635-0.014 0.055-0.022 0.109-0.026 0.163-2.541 2.596-6.084 4.208-10.004 4.208z" />
    </svg>
  ),
  radioUnchecked: (
    <svg viewBox="0 0 32 32">
      <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 28c-6.627 0-12-5.373-12-12s5.373-12 12-12c6.627 0 12 5.373 12 12s-5.373 12-12 12z" />
    </svg>
  ),
  radioChecked: (
    <svg viewBox="0 0 32 32">
      <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 28c-6.627 0-12-5.373-12-12s5.373-12 12-12c6.627 0 12 5.373 12 12s-5.373 12-12 12zM10 16c0-3.314 2.686-6 6-6s6 2.686 6 6c0 3.314-2.686 6-6 6s-6-2.686-6-6z" />
    </svg>
  ),
  lockedCabin: (
    <svg viewBox="0 0 290 290.2">
      <g>
        <path
          className="st0"
          d="M290,120.7L145.1,3.3h-0.2L0,120.7v19.2h27.2v147h74.7h86h75.4L262.7,140h27.2v-19.3H290z M245.1,188.1
L245.1,188.1L245.1,188.1c0,1,0,1.8-0.1,2.8c0,0.1,0,0.1,0,0.2c-1.1,18.8-11.7,35.1-27.2,43.5c-7.7,4.3-16.5,6.7-25.9,6.7
c-26.1,0-47.8-18.8-52.4-43.7c-5.8,0-17.5,0-41.8,0c0,0,0,0,0,39.3c0,0,0,0-15.9,0c0,0,0,0,0-24.4c0,0,0,0-21.1,0c0,0,0,0,0,23.8
c0,0,0,0-15.9,0c0,0,0,0,0-66.1c0,0,0,0,97.2,0c7.4-20.5,27-35.1,50.1-35.1c11.3,0,21.8,3.6,30.4,9.6c0.4,0.2,0.6,0.5,1,0.7
c0.2,0.1,0.5,0.4,0.7,0.5c4.6,3.5,8.6,7.7,11.9,12.5c0.1,0.1,0.1,0.2,0.2,0.2c0.4,0.5,0.6,1,1,1.4c0.2,0.2,0.4,0.6,0.6,0.8
c0.1,0.2,0.4,0.6,0.5,0.8c0.2,0.5,0.6,1.1,0.8,1.6v0.1C242.8,170.7,245.1,179.1,245.1,188.1L245.1,188.1z"
        />
        <path
          d="M191.9,163.9c-2,0-4,0.2-5.8,0.7c-10.7,2.6-18.6,12.1-18.6,23.6c0,13.4,10.9,24.3,24.3,24.3c0.1,0,0.2,0,0.4,0
c13.3-0.1,24-11,24-24.3C216.2,174.6,205.3,163.9,191.9,163.9z"
        />
      </g>
    </svg>
  ),
  addTour: (
    <svg viewBox="0 0 291.9 255.4">
      <g>
        <path
          d="M230.9,125.9H202v-29c0-2.2-1.3-3.2-3-3.2h-13.5c-1.8,0-3,1-3,3.2V126h-29.1c-2.4,0-3.2,1.1-3.2,2.9V140c0,1.8,0.8,3,3.2,3
        h29.1v29c0,2.2,1.3,3.2,3,3.2h13.5c1.8,0,3-1,3-3.2v-29h29c2.2,0,3.2-1.3,3.2-3v-11.1C234.1,127.1,233.1,125.9,230.9,125.9z"
        />
        <path
          d="M291.9,9.2c0-3-1.6-5.8-4-7.6c-2.6-1.7-5.7-2-8.5-0.8l-87.8,35l-87.8-35c-2.3-1-4.6-1-6.8,0L5.7,37.2
        C2.3,38.5,0,41.9,0,45.6v200.6c0,3,1.6,5.8,4,7.5c1.6,1,3.3,1.6,5.1,1.6c1.1,0,2.3-0.1,3.4-0.7l87.8-35l87.8,35c2.3,1,4.6,1,6.8,0
        l91.2-36.5c3.4-1.3,5.7-4.7,5.7-8.4L291.9,9.2z M95.8,201.8l-77.5,30.9v-181l77.5-30.9V201.8z M273.6,203.7L273.6,203.7l-77.5,30.9
        v-43.4H187v43.4l-82.1-32.8v-181L187,53.6v24.1h9.1V53.6l77.5-30.9L273.6,203.7z"
        />
      </g>
    </svg>
  ),
};

const Icon = (props) => {
  const { name } = props;
  return <span className="icon">{icons[name]}</span>;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Icon;
